export const backgroundImages = {
  desktop_bg: require('@/assets/desktop/desktop_bg.png'),

  // 手机买门票，主流程图片
  admissionFeeDyIndex2: require('@/assets/travel/admissionFee/dy/1-2.jpg'),
  admissionFeeDyIndex3: require('@/assets/travel/admissionFee/dy/1-3.jpg'),
  admissionFeeDyIndex4: require('@/assets/travel/admissionFee/dy/1-4.jpg'),
  admissionFeeDyIndex5: require('@/assets/travel/admissionFee/dy/1-5.jpg'),
  admissionFeeDyIndex6: require('@/assets/travel/admissionFee/dy/1-6.jpg'),
  admissionFeeDyIndex7: require('@/assets/travel/admissionFee/dy/1-7.jpg'),
  admissionFeeDyIndex8: require('@/assets/travel/admissionFee/dy/1-8.jpg'),
  admissionFeeDyIndex9: require('@/assets/travel/admissionFee/dy/1-9.jpg'),
  admissionFeeDyIndex10: require('@/assets/travel/admissionFee/dy/1-10.jpg'),
  admissionFeeDyIndex11: require('@/assets/travel/admissionFee/dy/1-11.jpg'),
  admissionFeeDyIndex12: require('@/assets/travel/admissionFee/dy/1-12.jpg'),
  admissionFeeDyIndex13: require('@/assets/travel/admissionFee/dy/1-13.jpg'),
  admissionFeeDyIndex14: require('@/assets/travel/admissionFee/dy/1-14.jpg'),
  admissionFeeDyIndex15: require('@/assets/travel/admissionFee/dy/1-15.jpg'),
  admissionFeeDyIndex16: require('@/assets/travel/admissionFee/dy/1-16.jpg'),
  admissionFeeDyIndex17: require('@/assets/travel/admissionFee/dy/1-17.jpg'),
  admissionFeeDyIndex18: require('@/assets/travel/admissionFee/dy/1-18.jpg'),
  admissionFeeDyIndex19: require('@/assets/travel/admissionFee/dy/1-19.jpg'),
  admissionFeeDyIndex20: require('@/assets/travel/admissionFee/dy/1-20.jpg'),
  branchAdmissionFeeDyIndex1: require('@/assets/travel/admissionFee/dy/2-1.jpg'),
  branchAdmissionFeeDyIndex2: require('@/assets/travel/admissionFee/dy/2-2.jpg'),
  branchAdmissionFeeDyIndex3: require('@/assets/travel/admissionFee/dy/2-3.jpg'),
  branchAdmissionFeeDyIndex4: require('@/assets/travel/admissionFee/dy/2-4.jpg'),
  branchAdmissionFeeDyIndex5: require('@/assets/travel/admissionFee/dy/2-5.jpg'),
  branchAdmissionFeeDyIndex6: require('@/assets/travel/admissionFee/dy/2-6.jpg'),
  branchAdmissionFeeDyIndex7: require('@/assets/travel/admissionFee/dy/2-7.jpg'),
  branchAdmissionFeeDyIndex8: require('@/assets/travel/admissionFee/dy/2-8.jpg'),
  branchAdmissionFeeDyIndex9: require('@/assets/travel/admissionFee/dy/2-9.jpg'),

  admissionFeeMtIndex2: require('@/assets/travel/admissionFee/mt/1-2.jpg'),
  admissionFeeMtIndex3: require('@/assets/travel/admissionFee/mt/1-3.jpg'),
  admissionFeeMtIndex4: require('@/assets/travel/admissionFee/mt/1-4.jpg'),
  admissionFeeMtIndex5: require('@/assets/travel/admissionFee/mt/1-5.jpg'),
  admissionFeeMtIndex6: require('@/assets/travel/admissionFee/mt/1-6.jpg'),
  admissionFeeMtIndex7: require('@/assets/travel/admissionFee/mt/1-7.jpg'),
  admissionFeeMtIndex8: require('@/assets/travel/admissionFee/mt/1-8.jpg'),
  admissionFeeMtIndex9: require('@/assets/travel/admissionFee/mt/1-9.jpg'),
  admissionFeeMtIndex10: require('@/assets/travel/admissionFee/mt/1-10.jpg'),
  admissionFeeMtIndex11: require('@/assets/travel/admissionFee/mt/1-11.jpg'),
  admissionFeeMtIndex12: require('@/assets/travel/admissionFee/mt/1-12.jpg'),
  admissionFeeMtIndex13: require('@/assets/travel/admissionFee/mt/1-13.jpg'),
  admissionFeeMtIndex14: require('@/assets/travel/admissionFee/mt/1-14.jpg'),
  admissionFeeMtIndex15: require('@/assets/travel/admissionFee/mt/1-15.jpg'),
  admissionFeeMtIndex16: require('@/assets/travel/admissionFee/mt/1-16.jpg'),
  admissionFeeMtIndex17: require('@/assets/travel/admissionFee/mt/1-17.jpg'),
  admissionFeeMtIndex18: require('@/assets/travel/admissionFee/mt/1-18.jpg'),
  admissionFeeMtIndex19: require('@/assets/travel/admissionFee/mt/1-19.jpg'),
  admissionFeeMtIndex20: require('@/assets/travel/admissionFee/mt/1-20.jpg'),
  admissionFeeMtIndex21: require('@/assets/travel/admissionFee/mt/1-21.jpg'),
  branchAdmissionFeeMtIndex1: require('@/assets/travel/admissionFee/mt/2-1.jpg'),
  branchAdmissionFeeMtIndex2: require('@/assets/travel/admissionFee/mt/2-2.jpg'),
  branchAdmissionFeeMtIndex3: require('@/assets/travel/admissionFee/mt/2-3.jpg'),
  branchAdmissionFeeMtIndex4: require('@/assets/travel/admissionFee/mt/2-4.jpg'),
  branchAdmissionFeeMtIndex5: require('@/assets/travel/admissionFee/mt/2-5.jpg'),
  branchAdmissionFeeMtIndex6: require('@/assets/travel/admissionFee/mt/2-6.jpg'),
  branchAdmissionFeeMtIndex7: require('@/assets/travel/admissionFee/mt/2-7.jpg'),

  admissionFeeXcIndex2: require('@/assets/travel/admissionFee/xc/1-2.jpg'),
  admissionFeeXcIndex3: require('@/assets/travel/admissionFee/xc/1-3.jpg'),
  admissionFeeXcIndex4: require('@/assets/travel/admissionFee/xc/1-4.jpg'),
  admissionFeeXcIndex5: require('@/assets/travel/admissionFee/xc/1-5.jpg'),
  admissionFeeXcIndex6: require('@/assets/travel/admissionFee/xc/1-6.jpg'),
  admissionFeeXcIndex7: require('@/assets/travel/admissionFee/xc/1-7.jpg'),
  admissionFeeXcIndex8: require('@/assets/travel/admissionFee/xc/1-8.jpg'),
  admissionFeeXcIndex9: require('@/assets/travel/admissionFee/xc/1-9.jpg'),
  admissionFeeXcIndex10: require('@/assets/travel/admissionFee/xc/1-10.jpg'),
  admissionFeeXcIndex11: require('@/assets/travel/admissionFee/xc/1-11.jpg'),
  admissionFeeXcIndex12: require('@/assets/travel/admissionFee/xc/1-12.jpg'),
  admissionFeeXcIndex13: require('@/assets/travel/admissionFee/xc/1-13.jpg'),
  admissionFeeXcIndex14: require('@/assets/travel/admissionFee/xc/1-14.jpg'),
  admissionFeeXcIndex15: require('@/assets/travel/admissionFee/xc/1-15.jpg'),
  admissionFeeXcIndex16: require('@/assets/travel/admissionFee/xc/1-16.jpg'),
  admissionFeeXcIndex17: require('@/assets/travel/admissionFee/xc/1-17.jpg'),
  admissionFeeXcIndex18: require('@/assets/travel/admissionFee/xc/1-18.jpg'),
  admissionFeeXcIndex19: require('@/assets/travel/admissionFee/xc/1-19.jpg'),
  branchAdmissionFeeXcIndex1: require('@/assets/travel/admissionFee/xc/2-1.jpg'),
  branchAdmissionFeeXcIndex2: require('@/assets/travel/admissionFee/xc/2-2.jpg'),
  branchAdmissionFeeXcIndex3: require('@/assets/travel/admissionFee/xc/2-3.jpg'),
  branchAdmissionFeeXcIndex4: require('@/assets/travel/admissionFee/xc/2-4.jpg'),
  branchAdmissionFeeXcIndex5: require('@/assets/travel/admissionFee/xc/2-5.jpg'),
  branchAdmissionFeeXcIndex6: require('@/assets/travel/admissionFee/xc/2-6.jpg'),
  branchAdmissionFeeXcIndex7: require('@/assets/travel/admissionFee/xc/2-7.jpg'),
  branchAdmissionFeeXcIndex8: require('@/assets/travel/admissionFee/xc/2-8.jpg'),
  branchAdmissionFeeXcIndex9: require('@/assets/travel/admissionFee/xc/2-9.jpg'),

  // 预定酒店，主流程图片
  hotelDyIndex2: require('@/assets/travel/hotel/dy/1-2.jpg'),
  hotelDyIndex3: require('@/assets/travel/hotel/dy/1-3.jpg'),
  hotelDyIndex4: require('@/assets/travel/hotel/dy/1-4.jpg'),
  hotelDyIndex5: require('@/assets/travel/hotel/dy/1-5.jpg'),
  hotelDyIndex6: require('@/assets/travel/hotel/dy/1-6.jpg'),
  hotelDyIndex7: require('@/assets/travel/hotel/dy/1-7.jpg'),
  hotelDyIndex8: require('@/assets/travel/hotel/dy/1-8.jpg'),
  hotelDyIndex9: require('@/assets/travel/hotel/dy/1-9.jpg'),
  hotelDyIndex10: require('@/assets/travel/hotel/dy/1-10.jpg'),
  hotelDyIndex11: require('@/assets/travel/hotel/dy/1-11.jpg'),
  hotelDyIndex12: require('@/assets/travel/hotel/dy/1-12.jpg'),
  hotelDyIndex13: require('@/assets/travel/hotel/dy/1-13.jpg'),
  hotelDyIndex14: require('@/assets/travel/hotel/dy/1-14.jpg'),
  hotelDyIndex15: require('@/assets/travel/hotel/dy/1-15.jpg'),
  hotelDyIndex16: require('@/assets/travel/hotel/dy/1-16.jpg'),
  hotelDyIndex17: require('@/assets/travel/hotel/dy/1-17.jpg'),
  hotelDyIndex18: require('@/assets/travel/hotel/dy/1-18.jpg'),
  hotelDyIndex19: require('@/assets/travel/hotel/dy/1-19.jpg'),
  hotelDyIndex20: require('@/assets/travel/hotel/dy/1-20.jpg'),
  hotelDyIndex21: require('@/assets/travel/hotel/dy/1-21.jpg'),
  hotelDyIndex22: require('@/assets/travel/hotel/dy/1-22.jpg'),
  hotelDyIndex23: require('@/assets/travel/hotel/dy/1-23.jpg'),
  hotelDyIndex24: require('@/assets/travel/hotel/dy/1-24.jpg'),
  branchHotelDyIndex1: require('@/assets/travel/hotel/dy/2-1.jpg'),
  branchHotelDyIndex2: require('@/assets/travel/hotel/dy/2-2.jpg'),
  branchHotelDyIndex3: require('@/assets/travel/hotel/dy/2-3.jpg'),
  branchHotelDyIndex4: require('@/assets/travel/hotel/dy/2-4.jpg'),
  branchHotelDyIndex5: require('@/assets/travel/hotel/dy/2-5.jpg'),
  branchHotelDyIndex6: require('@/assets/travel/hotel/dy/2-6.jpg'),
  branchHotelDyIndex7: require('@/assets/travel/hotel/dy/2-7.jpg'),
  branchHotelDyIndex8: require('@/assets/travel/hotel/dy/2-8.jpg'),

  hotelMtIndex2: require('@/assets/travel/hotel/mt/1-2.jpg'),
  hotelMtIndex3: require('@/assets/travel/hotel/mt/1-3.jpg'),
  hotelMtIndex4: require('@/assets/travel/hotel/mt/1-4.jpg'),
  hotelMtIndex5: require('@/assets/travel/hotel/mt/1-5.jpg'),
  hotelMtIndex6: require('@/assets/travel/hotel/mt/1-6.jpg'),
  hotelMtIndex7: require('@/assets/travel/hotel/mt/1-7.jpg'),
  hotelMtIndex8: require('@/assets/travel/hotel/mt/1-8.jpg'),
  hotelMtIndex9: require('@/assets/travel/hotel/mt/1-9.jpg'),
  hotelMtIndex10: require('@/assets/travel/hotel/mt/1-10.jpg'),
  hotelMtIndex11: require('@/assets/travel/hotel/mt/1-11.jpg'),
  hotelMtIndex12: require('@/assets/travel/hotel/mt/1-12.jpg'),
  hotelMtIndex13: require('@/assets/travel/hotel/mt/1-13.jpg'),
  hotelMtIndex14: require('@/assets/travel/hotel/mt/1-14.jpg'),
  hotelMtIndex15: require('@/assets/travel/hotel/mt/1-15.jpg'),
  hotelMtIndex16: require('@/assets/travel/hotel/mt/1-16.jpg'),
  hotelMtIndex17: require('@/assets/travel/hotel/mt/1-17.jpg'),
  hotelMtIndex18: require('@/assets/travel/hotel/mt/1-18.jpg'),
  hotelMtIndex19: require('@/assets/travel/hotel/mt/1-19.jpg'),
  hotelMtIndex20: require('@/assets/travel/hotel/mt/1-20.jpg'),
  hotelMtIndex21: require('@/assets/travel/hotel/mt/1-21.jpg'),
  branchHotelMtIndex1: require('@/assets/travel/hotel/mt/2-1.jpg'),
  branchHotelMtIndex2: require('@/assets/travel/hotel/mt/2-2.jpg'),
  branchHotelMtIndex3: require('@/assets/travel/hotel/mt/2-3.jpg'),
  branchHotelMtIndex4: require('@/assets/travel/hotel/mt/2-4.jpg'),
  branchHotelMtIndex5: require('@/assets/travel/hotel/mt/2-5.jpg'),
  branchHotelMtIndex6: require('@/assets/travel/hotel/mt/2-6.jpg'),

  hotelXcIndex2: require('@/assets/travel/hotel/xc/1-2.jpg'),
  hotelXcIndex3: require('@/assets/travel/hotel/xc/1-3.jpg'),
  hotelXcIndex4: require('@/assets/travel/hotel/xc/1-4.jpg'),
  hotelXcIndex5: require('@/assets/travel/hotel/xc/1-5.jpg'),
  hotelXcIndex6: require('@/assets/travel/hotel/xc/1-6.jpg'),
  hotelXcIndex7: require('@/assets/travel/hotel/xc/1-7.jpg'),
  hotelXcIndex8: require('@/assets/travel/hotel/xc/1-8.jpg'),
  hotelXcIndex9: require('@/assets/travel/hotel/xc/1-9.jpg'),
  hotelXcIndex10: require('@/assets/travel/hotel/xc/1-10.jpg'),
  hotelXcIndex11: require('@/assets/travel/hotel/xc/1-11.jpg'),
  hotelXcIndex12: require('@/assets/travel/hotel/xc/1-12.jpg'),
  hotelXcIndex13: require('@/assets/travel/hotel/xc/1-13.jpg'),
  hotelXcIndex14: require('@/assets/travel/hotel/xc/1-14.jpg'),
  hotelXcIndex15: require('@/assets/travel/hotel/xc/1-15.jpg'),
  hotelXcIndex16: require('@/assets/travel/hotel/xc/1-16.jpg'),
  hotelXcIndex17: require('@/assets/travel/hotel/xc/1-17.jpg'),
  hotelXcIndex18: require('@/assets/travel/hotel/xc/1-18.jpg'),
  branchHotelXcIndex1: require('@/assets/travel/hotel/xc/2-1.jpg'),
  branchHotelXcIndex2: require('@/assets/travel/hotel/xc/2-2.jpg'),
  branchHotelXcIndex3: require('@/assets/travel/hotel/xc/2-3.jpg'),
  branchHotelXcIndex4: require('@/assets/travel/hotel/xc/2-4.jpg'),
  branchHotelXcIndex5: require('@/assets/travel/hotel/xc/2-5.jpg'),
  branchHotelXcIndex6: require('@/assets/travel/hotel/xc/2-6.jpg'),
  branchHotelXcIndex7: require('@/assets/travel/hotel/xc/2-7.jpg'),

  // 手机报团，主流程图片
  groupMtIndex2: require('@/assets/travel/group/mt/1-2.jpg'),
  groupMtIndex3: require('@/assets/travel/group/mt/1-3.jpg'),
  groupMtIndex4: require('@/assets/travel/group/mt/1-4.jpg'),
  groupMtIndex5: require('@/assets/travel/group/mt/1-5.jpg'),
  groupMtIndex6: require('@/assets/travel/group/mt/1-6.jpg'),
  groupMtIndex7: require('@/assets/travel/group/mt/1-7.jpg'),
  groupMtIndex8: require('@/assets/travel/group/mt/1-8.jpg'),
  groupMtIndex9: require('@/assets/travel/group/mt/1-9.jpg'),
  groupMtIndex10: require('@/assets/travel/group/mt/1-10.jpg'),
  groupMtIndex11: require('@/assets/travel/group/mt/1-11.jpg'),
  groupMtIndex12: require('@/assets/travel/group/mt/1-12.jpg'),
  groupMtIndex13: require('@/assets/travel/group/mt/1-13.jpg'),
  groupMtIndex14: require('@/assets/travel/group/mt/1-14.jpg'),
  groupMtIndex15: require('@/assets/travel/group/mt/1-15.jpg'),
  groupMtIndex16: require('@/assets/travel/group/mt/1-16.jpg'),
  groupMtIndex17: require('@/assets/travel/group/mt/1-17.jpg'),
  groupMtIndex18: require('@/assets/travel/group/mt/1-18.jpg'),
  groupMtIndex19: require('@/assets/travel/group/mt/1-19.jpg'),
  groupMtIndex20: require('@/assets/travel/group/mt/1-20.jpg'),
  groupMtIndex21: require('@/assets/travel/group/mt/1-21.jpg'),
  groupMtIndex22: require('@/assets/travel/group/mt/1-22.jpg'),
  groupMtIndex23: require('@/assets/travel/group/mt/1-23.jpg'),
  groupMtIndex24: require('@/assets/travel/group/mt/1-24.jpg'),
  groupMtIndex25: require('@/assets/travel/group/mt/1-25.jpg'),

  groupXcIndex2: require('@/assets/travel/group/xc/1-2.jpg'),
  groupXcIndex3: require('@/assets/travel/group/xc/1-3.jpg'),
  groupXcIndex4: require('@/assets/travel/group/xc/1-4.jpg'),
  groupXcIndex5: require('@/assets/travel/group/xc/1-5.jpg'),
  groupXcIndex6: require('@/assets/travel/group/xc/1-6.jpg'),
  groupXcIndex7: require('@/assets/travel/group/xc/1-7.jpg'),
  groupXcIndex8: require('@/assets/travel/group/xc/1-8.jpg'),
  groupXcIndex9: require('@/assets/travel/group/xc/1-9.jpg'),
  groupXcIndex10: require('@/assets/travel/group/xc/1-10.jpg'),
  groupXcIndex11: require('@/assets/travel/group/xc/1-11.jpg'),
  groupXcIndex12: require('@/assets/travel/group/xc/1-12.jpg'),
  groupXcIndex13: require('@/assets/travel/group/xc/1-13.jpg'),
  groupXcIndex14: require('@/assets/travel/group/xc/1-14.jpg'),
  groupXcIndex15: require('@/assets/travel/group/xc/1-15.jpg'),
  groupXcIndex16: require('@/assets/travel/group/xc/1-16.jpg'),
  groupXcIndex17: require('@/assets/travel/group/xc/1-17.jpg'),
  groupXcIndex18: require('@/assets/travel/group/xc/1-18.jpg'),
  groupXcIndex19: require('@/assets/travel/group/xc/1-19.jpg'),
  groupXcIndex20: require('@/assets/travel/group/xc/1-20.jpg'),
  groupXcIndex21: require('@/assets/travel/group/xc/1-21.jpg'),
  groupXcIndex22: require('@/assets/travel/group/xc/1-22.jpg'),
  groupXcIndex23: require('@/assets/travel/group/xc/1-23.jpg'),
  groupXcIndex24: require('@/assets/travel/group/xc/1-24.jpg'),
  groupXcIndex25: require('@/assets/travel/group/xc/1-25.jpg'),
  groupXcIndex26: require('@/assets/travel/group/xc/1-26.jpg'),
  groupXcIndex27: require('@/assets/travel/group/xc/1-27.jpg'),
  groupXcIndex28: require('@/assets/travel/group/xc/1-28.jpg'),
  groupXcIndex29: require('@/assets/travel/group/xc/1-29.jpg'),
  groupXcIndex30: require('@/assets/travel/group/xc/1-30.jpg'),
  groupXcIndex31: require('@/assets/travel/group/xc/1-31.jpg'),
  groupXcIndex32: require('@/assets/travel/group/xc/1-32.jpg'),
  groupXcIndex33: require('@/assets/travel/group/xc/1-33.jpg'),
  groupXcIndex34: require('@/assets/travel/group/xc/1-34.jpg'),

  // 手机看剧 爱奇艺视频
  seeAqyIndex1: require('@/assets/entertainment/see/aqy/1-1.jpg'),
  seeAqyIndex2: require('@/assets/entertainment/see/aqy/1-2.jpg'),
  seeAqyIndex3: require('@/assets/entertainment/see/aqy/1-3.jpg'),
  seeAqyIndex4: require('@/assets/entertainment/see/aqy/1-4.jpg'),
  seeAqyIndex5: require('@/assets/entertainment/see/aqy/1-5.jpg'),
  seeAqyIndex6: require('@/assets/entertainment/see/aqy/1-6.jpg'),
  seeAqyIndex7: require('@/assets/entertainment/see/aqy/1-7.jpg'),
  seeAqyIndex8: require('@/assets/entertainment/see/aqy/1-8.jpg'),
  seeAqyIndex9: require('@/assets/entertainment/see/aqy/1-9.jpg'),
  seeAqyIndex10: require('@/assets/entertainment/see/aqy/1-10.jpg'),

  // 手机看剧 腾讯视频
  seeTxIndex1: require('@/assets/entertainment/see/tx/1-1.jpg'),
  seeTxIndex2: require('@/assets/entertainment/see/tx/1-2.jpg'),
  seeTxIndex3: require('@/assets/entertainment/see/tx/1-3.jpg'),
  seeTxIndex4: require('@/assets/entertainment/see/tx/1-4.jpg'),
  seeTxIndex5: require('@/assets/entertainment/see/tx/1-5.jpg'),
  seeTxIndex6: require('@/assets/entertainment/see/tx/1-6.jpg'),
  seeTxIndex7: require('@/assets/entertainment/see/tx/1-7.jpg'),
  seeTxIndex8: require('@/assets/entertainment/see/tx/1-8.jpg'),
  seeTxIndex9: require('@/assets/entertainment/see/tx/1-9.jpg'),
  seeTxIndex10: require('@/assets/entertainment/see/tx/1-10.jpg'),
  seeTxIndex11: require('@/assets/entertainment/see/tx/1-11.jpg'),
  seeTxIndex12: require('@/assets/entertainment/see/tx/1-12.jpg'),

  // 视频拍摄，主流程图片
  videoIndex2: require('@/assets/travel/video/1-2.jpg'),
  videoIndex3: require('@/assets/travel/video/1-3.jpg'),
  videoIndex4: require('@/assets/travel/video/1-4.jpg'),
  videoIndex5: require('@/assets/travel/video/1-5.jpg'),
  videoIndex6: require('@/assets/travel/video/1-6.jpg'),
  videoIndex7: require('@/assets/travel/video/1-7.jpg'),
  videoIndex8: require('@/assets/travel/video/1-8.jpg'),
  videoIndex9: require('@/assets/travel/video/1-9.jpg'),
  videoIndex10: require('@/assets/travel/video/1-10.jpg'),
  videoIndex11: require('@/assets/travel/video/1-11.jpg'),
  videoIndex12: require('@/assets/travel/video/1-12.jpg'),
  videoIndex13: require('@/assets/travel/video/1-13.jpg'),

  // 照片拍摄，主流程图片
  photoIndex2: require('@/assets/travel/photo/1-2.jpg'),
  photoIndex3: require('@/assets/travel/photo/1-3.jpg'),
  photoIndex4: require('@/assets/travel/photo/1-4.jpg'),
  photoIndex5: require('@/assets/travel/photo/1-5.jpg'),
  photoIndex6: require('@/assets/travel/photo/1-6.jpg'),
  photoIndex7: require('@/assets/travel/photo/1-7.jpg'),
  photoIndex8: require('@/assets/travel/photo/1-8.jpg'),
  photoIndex9: require('@/assets/travel/photo/1-9.jpg'),
  photoIndex10: require('@/assets/travel/photo/1-10.jpg'),
  photoIndex11: require('@/assets/travel/photo/1-11.jpg'),
  photoIndex12: require('@/assets/travel/photo/1-12.jpg'),
  photoIndex13: require('@/assets/travel/photo/1-13.jpg'),
  photoIndex14: require('@/assets/travel/photo/1-14.jpg'),

  // 人物美颜,主流程剪映
  beautifulJyIndex2: require('@/assets/edit/beautiful/jy/1-2.jpg'),
  beautifulJyIndex3: require('@/assets/edit/beautiful/jy/1-3.jpg'),
  beautifulJyIndex4: require('@/assets/edit/beautiful/jy/1-4.jpg'),
  beautifulJyIndex5: require('@/assets/edit/beautiful/jy/1-5.jpg'),
  beautifulJyIndex6: require('@/assets/edit/beautiful/jy/1-6.jpg'),
  beautifulJyIndex7: require('@/assets/edit/beautiful/jy/1-7.jpg'),
  beautifulJyIndex8: require('@/assets/edit/beautiful/jy/1-8.jpg'),
  beautifulJyIndex9: require('@/assets/edit/beautiful/jy/1-9.jpg'),
  beautifulJyIndex10: require('@/assets/edit/beautiful/jy/1-10.jpg'),
  beautifulJyIndex11: require('@/assets/edit/beautiful/jy/1-11.jpg'),
  beautifulJyIndex12: require('@/assets/edit/beautiful/jy/1-12.jpg'),
  beautifulJyIndex13: require('@/assets/edit/beautiful/jy/1-13.jpg'),
  beautifulJyIndex14: require('@/assets/edit/beautiful/jy/1-14.jpg'),
  beautifulJyIndex15: require('@/assets/edit/beautiful/jy/1-15.jpg'),
  beautifulJyIndex16: require('@/assets/edit/beautiful/jy/1-16.jpg'),
  beautifulJyIndex17: require('@/assets/edit/beautiful/jy/1-17.jpg'),
  beautifulJyIndex18: require('@/assets/edit/beautiful/jy/1-18.jpg'),
  beautifulJyIndex19: require('@/assets/edit/beautiful/jy/1-19.jpg'),
  beautifulJyIndex20: require('@/assets/edit/beautiful/jy/1-20.jpg'),
  beautifulJyIndex21: require('@/assets/edit/beautiful/jy/1-21.jpg'),
  beautifulJyIndex22: require('@/assets/edit/beautiful/jy/1-22.jpg'),
  beautifulJyIndex23: require('@/assets/edit/beautiful/jy/1-23.jpg'),
  beautifulJyIndex24: require('@/assets/edit/beautiful/jy/1-24.jpg'),

  // 人物美颜,主流程醒图
  beautifulXtIndex2: require('@/assets/edit/beautiful/xt/1-2.jpg'),
  beautifulXtIndex3: require('@/assets/edit/beautiful/xt/1-3.jpg'),
  beautifulXtIndex4: require('@/assets/edit/beautiful/xt/1-4.jpg'),
  beautifulXtIndex5: require('@/assets/edit/beautiful/xt/1-5.jpg'),
  beautifulXtIndex6: require('@/assets/edit/beautiful/xt/1-6.jpg'),
  beautifulXtIndex7: require('@/assets/edit/beautiful/xt/1-7.jpg'),
  beautifulXtIndex8: require('@/assets/edit/beautiful/xt/1-8.jpg'),
  beautifulXtIndex9: require('@/assets/edit/beautiful/xt/1-9.jpg'),
  beautifulXtIndex10: require('@/assets/edit/beautiful/xt/1-10.jpg'),
  beautifulXtIndex11: require('@/assets/edit/beautiful/xt/1-11.jpg'),
  beautifulXtIndex12: require('@/assets/edit/beautiful/xt/1-12.jpg'),
  beautifulXtIndex13: require('@/assets/edit/beautiful/xt/1-13.jpg'),
  beautifulXtIndex14: require('@/assets/edit/beautiful/xt/1-14.jpg'),
  beautifulXtIndex15: require('@/assets/edit/beautiful/xt/1-15.jpg'),
  beautifulXtIndex16: require('@/assets/edit/beautiful/xt/1-16.jpg'),
  beautifulXtIndex17: require('@/assets/edit/beautiful/xt/1-17.jpg'),
  beautifulXtIndex18: require('@/assets/edit/beautiful/xt/1-18.jpg'),
  beautifulXtIndex19: require('@/assets/edit/beautiful/xt/1-19.jpg'),
  beautifulXtIndex20: require('@/assets/edit/beautiful/xt/1-20.jpg'),
  beautifulXtIndex21: require('@/assets/edit/beautiful/xt/1-21.jpg'),
  beautifulXtIndex22: require('@/assets/edit/beautiful/xt/1-22.jpg'),
  beautifulXtIndex23: require('@/assets/edit/beautiful/xt/1-23.jpg'),
  beautifulXtIndex24: require('@/assets/edit/beautiful/xt/1-24.jpg'),
  beautifulXtIndex25: require('@/assets/edit/beautiful/xt/1-25.jpg'),

  // AI,主流程剪辑视频
  aiJspIndex2: require('@/assets/edit/ai/jsp/1-2.jpg'),
  aiJspIndex3: require('@/assets/edit/ai/jsp/1-3.jpg'),
  aiJspIndex4: require('@/assets/edit/ai/jsp/1-4.jpg'),
  aiJspIndex5: require('@/assets/edit/ai/jsp/1-5.jpg'),
  aiJspIndex6: require('@/assets/edit/ai/jsp/1-6.jpg'),
  aiJspIndex7: require('@/assets/edit/ai/jsp/1-7.jpg'),
  aiJspIndex8: require('@/assets/edit/ai/jsp/1-8.jpg'),
  aiJspIndex9: require('@/assets/edit/ai/jsp/1-9.jpg'),
  aiJspIndex10: require('@/assets/edit/ai/jsp/1-10.jpg'),
  aiJspIndex11: require('@/assets/edit/ai/jsp/1-11.jpg'),
  aiJspIndex12: require('@/assets/edit/ai/jsp/1-12.jpg'),
  aiJspIndex13: require('@/assets/edit/ai/jsp/1-13.jpg'),
  aiJspIndex14: require('@/assets/edit/ai/jsp/1-14.jpg'),
  aiJspIndex15: require('@/assets/edit/ai/jsp/1-15.jpg'),

  // AI,主流程配音
  aiPyIndex2: require('@/assets/edit/ai/py/1-2.jpg'),
  aiPyIndex3: require('@/assets/edit/ai/py/1-3.jpg'),
  aiPyIndex4: require('@/assets/edit/ai/py/1-4.jpg'),
  aiPyIndex5: require('@/assets/edit/ai/py/1-5.jpg'),
  aiPyIndex6: require('@/assets/edit/ai/py/1-6.jpg'),
  aiPyIndex7: require('@/assets/edit/ai/py/1-7.jpg'),
  aiPyIndex8: require('@/assets/edit/ai/py/1-8.jpg'),
  aiPyIndex9: require('@/assets/edit/ai/py/1-9.jpg'),
  aiPyIndex10: require('@/assets/edit/ai/py/1-10.jpg'),
  aiPyIndex11: require('@/assets/edit/ai/py/1-11.jpg'),
  aiPyIndex12: require('@/assets/edit/ai/py/1-12.jpg'),
  aiPyIndex13: require('@/assets/edit/ai/py/1-13.jpg'),
  aiPyIndex14: require('@/assets/edit/ai/py/1-14.jpg'),
  aiPyIndex15: require('@/assets/edit/ai/py/1-15.jpg'),
  aiPyIndex16: require('@/assets/edit/ai/py/1-16.jpg'),
  aiPyIndex17: require('@/assets/edit/ai/py/1-17.jpg'),

  // AI，图文成片
  aiTwcpIndex2: require('@/assets/edit/ai/twcp/1-2.jpg'),
  aiTwcpIndex3: require('@/assets/edit/ai/twcp/1-3.jpg'),
  aiTwcpIndex4: require('@/assets/edit/ai/twcp/1-4.jpg'),
  aiTwcpIndex5: require('@/assets/edit/ai/twcp/1-5.jpg'),
  aiTwcpIndex6: require('@/assets/edit/ai/twcp/1-6.jpg'),
  aiTwcpIndex7: require('@/assets/edit/ai/twcp/1-7.jpg'),
  aiTwcpIndex8: require('@/assets/edit/ai/twcp/1-8.jpg'),
  aiTwcpIndex9: require('@/assets/edit/ai/twcp/1-9.jpg'),
  aiTwcpIndex10: require('@/assets/edit/ai/twcp/1-10.jpg'),
  aiTwcpIndex11: require('@/assets/edit/ai/twcp/1-11.jpg'),
  aiTwcpIndex12: require('@/assets/edit/ai/twcp/1-12.jpg'),
  aiTwcpIndex13: require('@/assets/edit/ai/twcp/1-13.jpg'),
  aiTwcpIndex14: require('@/assets/edit/ai/twcp/1-14.jpg'),
  aiTwcpIndex15: require('@/assets/edit/ai/twcp/1-15.jpg'),
  aiTwcpIndex16: require('@/assets/edit/ai/twcp/1-16.jpg'),
  aiTwcpIndex17: require('@/assets/edit/ai/twcp/1-17.jpg'),

  // AI，一键成片
  aiYjcpIndex2: require('@/assets/edit/ai/yjcp/1-2.jpg'),
  aiYjcpIndex3: require('@/assets/edit/ai/yjcp/1-3.jpg'),
  aiYjcpIndex4: require('@/assets/edit/ai/yjcp/1-4.jpg'),
  aiYjcpIndex5: require('@/assets/edit/ai/yjcp/1-5.jpg'),
  aiYjcpIndex6: require('@/assets/edit/ai/yjcp/1-6.jpg'),
  aiYjcpIndex7: require('@/assets/edit/ai/yjcp/1-7.jpg'),
  aiYjcpIndex8: require('@/assets/edit/ai/yjcp/1-8.jpg'),
  aiYjcpIndex9: require('@/assets/edit/ai/yjcp/1-9.jpg'),
  aiYjcpIndex10: require('@/assets/edit/ai/yjcp/1-10.jpg'),
  aiYjcpIndex11: require('@/assets/edit/ai/yjcp/1-11.jpg'),
  aiYjcpIndex12: require('@/assets/edit/ai/yjcp/1-12.jpg'),
  aiYjcpIndex13: require('@/assets/edit/ai/yjcp/1-13.jpg'),
  aiYjcpIndex14: require('@/assets/edit/ai/yjcp/1-14.jpg'),

  // 文字添加,主流程剪映
  addJyIndex2: require('@/assets/edit/add/jy/1-2.jpg'),
  addJyIndex3: require('@/assets/edit/add/jy/1-3.jpg'),
  addJyIndex4: require('@/assets/edit/add/jy/1-4.jpg'),
  addJyIndex5: require('@/assets/edit/add/jy/1-5.jpg'),
  addJyIndex6: require('@/assets/edit/add/jy/1-6.jpg'),
  addJyIndex7: require('@/assets/edit/add/jy/1-7.jpg'),
  addJyIndex8: require('@/assets/edit/add/jy/1-8.jpg'),
  addJyIndex9: require('@/assets/edit/add/jy/1-9.jpg'),
  addJyIndex10: require('@/assets/edit/add/jy/1-10.jpg'),
  addJyIndex11: require('@/assets/edit/add/jy/1-11.jpg'),
  addJyIndex12: require('@/assets/edit/add/jy/1-12.jpg'),
  addJyIndex13: require('@/assets/edit/add/jy/1-13.jpg'),
  addJyIndex14: require('@/assets/edit/add/jy/1-14.jpg'),
  addJyIndex15: require('@/assets/edit/add/jy/1-15.jpg'),
  addJyIndex16: require('@/assets/edit/add/jy/1-16.jpg'),

  // 文字添加,主流程醒图
  addXtIndex2: require('@/assets/edit/add/xt/1-2.jpg'),
  addXtIndex3: require('@/assets/edit/add/xt/1-3.jpg'),
  addXtIndex4: require('@/assets/edit/add/xt/1-4.jpg'),
  addXtIndex5: require('@/assets/edit/add/xt/1-5.jpg'),
  addXtIndex6: require('@/assets/edit/add/xt/1-6.jpg'),
  addXtIndex7: require('@/assets/edit/add/xt/1-7.jpg'),
  addXtIndex8: require('@/assets/edit/add/xt/1-8.jpg'),
  addXtIndex9: require('@/assets/edit/add/xt/1-9.jpg'),
  addXtIndex10: require('@/assets/edit/add/xt/1-10.jpg'),
  addXtIndex11: require('@/assets/edit/add/xt/1-11.jpg'),
  addXtIndex12: require('@/assets/edit/add/xt/1-12.jpg'),
  addXtIndex13: require('@/assets/edit/add/xt/1-13.jpg'),
  addXtIndex14: require('@/assets/edit/add/xt/1-14.jpg'),
  addXtIndex15: require('@/assets/edit/add/xt/1-15.jpg'),
  addXtIndex16: require('@/assets/edit/add/xt/1-16.jpg'),
  addXtIndex17: require('@/assets/edit/add/xt/1-17.jpg'),
  addXtIndex18: require('@/assets/edit/add/xt/1-18.jpg'),
  addXtIndex19: require('@/assets/edit/add/xt/1-19.jpg'),

  // 瘦身美体，主流程图片
  slimmingJyIndex2: require('@/assets/edit/slimming/jy/1-2.jpg'),
  slimmingJyIndex3: require('@/assets/edit/slimming/jy/1-3.jpg'),
  slimmingJyIndex4: require('@/assets/edit/slimming/jy/1-4.jpg'),
  slimmingJyIndex5: require('@/assets/edit/slimming/jy/1-5.jpg'),
  slimmingJyIndex6: require('@/assets/edit/slimming/jy/1-6.jpg'),
  slimmingJyIndex7: require('@/assets/edit/slimming/jy/1-7.jpg'),
  slimmingJyIndex8: require('@/assets/edit/slimming/jy/1-8.jpg'),
  slimmingJyIndex9: require('@/assets/edit/slimming/jy/1-9.jpg'),
  slimmingJyIndex10: require('@/assets/edit/slimming/jy/1-10.jpg'),
  slimmingJyIndex11: require('@/assets/edit/slimming/jy/1-11.jpg'),
  slimmingJyIndex12: require('@/assets/edit/slimming/jy/1-12.jpg'),
  slimmingJyIndex13: require('@/assets/edit/slimming/jy/1-13.jpg'),
  slimmingJyIndex14: require('@/assets/edit/slimming/jy/1-14.jpg'),
  slimmingJyIndex15: require('@/assets/edit/slimming/jy/1-15.jpg'),
  slimmingJyIndex16: require('@/assets/edit/slimming/jy/1-16.jpg'),
  slimmingJyIndex17: require('@/assets/edit/slimming/jy/1-17.jpg'),
  slimmingJyIndex18: require('@/assets/edit/slimming/jy/1-18.jpg'),
  slimmingJyIndex19: require('@/assets/edit/slimming/jy/1-19.jpg'),
  slimmingJyIndex20: require('@/assets/edit/slimming/jy/1-20.jpg'),

  slimmingXtIndex2: require('@/assets/edit/slimming/xt/1-2.jpg'),
  slimmingXtIndex3: require('@/assets/edit/slimming/xt/1-3.jpg'),
  slimmingXtIndex4: require('@/assets/edit/slimming/xt/1-4.jpg'),
  slimmingXtIndex5: require('@/assets/edit/slimming/xt/1-5.jpg'),
  slimmingXtIndex6: require('@/assets/edit/slimming/xt/1-6.jpg'),
  slimmingXtIndex7: require('@/assets/edit/slimming/xt/1-7.jpg'),
  slimmingXtIndex8: require('@/assets/edit/slimming/xt/1-8.jpg'),
  slimmingXtIndex9: require('@/assets/edit/slimming/xt/1-9.jpg'),
  slimmingXtIndex10: require('@/assets/edit/slimming/xt/1-10.jpg'),
  slimmingXtIndex11: require('@/assets/edit/slimming/xt/1-11.jpg'),
  slimmingXtIndex12: require('@/assets/edit/slimming/xt/1-12.jpg'),
  slimmingXtIndex13: require('@/assets/edit/slimming/xt/1-13.jpg'),
  slimmingXtIndex14: require('@/assets/edit/slimming/xt/1-14.jpg'),
  slimmingXtIndex15: require('@/assets/edit/slimming/xt/1-15.jpg'),
  slimmingXtIndex16: require('@/assets/edit/slimming/xt/1-16.jpg'),
  slimmingXtIndex17: require('@/assets/edit/slimming/xt/1-17.jpg'),
  slimmingXtIndex18: require('@/assets/edit/slimming/xt/1-18.jpg'),
  slimmingXtIndex19: require('@/assets/edit/slimming/xt/1-19.jpg'),
  slimmingXtIndex20: require('@/assets/edit/slimming/xt/1-20.jpg'),
  slimmingXtIndex21: require('@/assets/edit/slimming/xt/1-21.jpg'),
  slimmingXtIndex22: require('@/assets/edit/slimming/xt/1-22.jpg'),
  slimmingXtIndex23: require('@/assets/edit/slimming/xt/1-23.jpg'),
  slimmingXtIndex24: require('@/assets/edit/slimming/xt/1-24.jpg'),
  slimmingXtIndex25: require('@/assets/edit/slimming/xt/1-25.jpg'),

  // 视频初剪，主流程
  videoClipsClipIndex2: require('@/assets/edit/videoClips/clip/1-2.jpg'),
  videoClipsClipIndex3: require('@/assets/edit/videoClips/clip/1-3.jpg'),
  videoClipsClipIndex4: require('@/assets/edit/videoClips/clip/1-4.jpg'),
  videoClipsClipIndex5: require('@/assets/edit/videoClips/clip/1-5.jpg'),
  videoClipsClipIndex6: require('@/assets/edit/videoClips/clip/1-6.jpg'),
  videoClipsClipIndex7: require('@/assets/edit/videoClips/clip/1-7.jpg'),
  videoClipsClipIndex8: require('@/assets/edit/videoClips/clip/1-8.jpg'),
  videoClipsClipIndex9: require('@/assets/edit/videoClips/clip/1-9.jpg'),
  videoClipsClipIndex10: require('@/assets/edit/videoClips/clip/1-10.jpg'),
  videoClipsClipIndex11: require('@/assets/edit/videoClips/clip/1-11.jpg'),
  videoClipsClipIndex12: require('@/assets/edit/videoClips/clip/1-12.jpg'),
  videoClipsClipIndex13: require('@/assets/edit/videoClips/clip/1-13.jpg'),
  videoClipsClipIndex14: require('@/assets/edit/videoClips/clip/1-14.jpg'),
  videoClipsClipIndex15: require('@/assets/edit/videoClips/clip/1-15.jpg'),
  videoClipsClipIndex16: require('@/assets/edit/videoClips/clip/1-16.jpg'),

  videoClipsAnimationIndex2: require('@/assets/edit/videoClips/animation/1-2.jpg'),
  videoClipsAnimationIndex3: require('@/assets/edit/videoClips/animation/1-3.jpg'),
  videoClipsAnimationIndex4: require('@/assets/edit/videoClips/animation/1-4.jpg'),
  videoClipsAnimationIndex5: require('@/assets/edit/videoClips/animation/1-5.jpg'),
  videoClipsAnimationIndex6: require('@/assets/edit/videoClips/animation/1-6.jpg'),
  videoClipsAnimationIndex7: require('@/assets/edit/videoClips/animation/1-7.jpg'),
  videoClipsAnimationIndex8: require('@/assets/edit/videoClips/animation/1-8.jpg'),
  videoClipsAnimationIndex9: require('@/assets/edit/videoClips/animation/1-9.jpg'),
  videoClipsAnimationIndex10: require('@/assets/edit/videoClips/animation/1-10.jpg'),
  videoClipsAnimationIndex11: require('@/assets/edit/videoClips/animation/1-11.jpg'),
  videoClipsAnimationIndex12: require('@/assets/edit/videoClips/animation/1-12.jpg'),
  videoClipsAnimationIndex13: require('@/assets/edit/videoClips/animation/1-13.jpg'),
  videoClipsAnimationIndex14: require('@/assets/edit/videoClips/animation/1-14.jpg'),
  videoClipsAnimationIndex15: require('@/assets/edit/videoClips/animation/1-15.jpg'),
  videoClipsAnimationIndex16: require('@/assets/edit/videoClips/animation/1-16.jpg'),
  videoClipsAnimationIndex17: require('@/assets/edit/videoClips/animation/1-17.jpg'),
  videoClipsAnimationIndex18: require('@/assets/edit/videoClips/animation/1-18.jpg'),
  videoClipsAnimationIndex19: require('@/assets/edit/videoClips/animation/1-19.jpg'),
  videoClipsAnimationIndex20: require('@/assets/edit/videoClips/animation/1-20.jpg'),
  videoClipsAnimationIndex21: require('@/assets/edit/videoClips/animation/1-21.jpg'),
  videoClipsAnimationIndex22: require('@/assets/edit/videoClips/animation/1-22.jpg'),
  videoClipsAnimationIndex23: require('@/assets/edit/videoClips/animation/1-23.jpg'),

  videoClipsSpecialIndex2: require('@/assets/edit/videoClips/special/1-2.jpg'),
  videoClipsSpecialIndex3: require('@/assets/edit/videoClips/special/1-3.jpg'),
  videoClipsSpecialIndex4: require('@/assets/edit/videoClips/special/1-4.jpg'),
  videoClipsSpecialIndex5: require('@/assets/edit/videoClips/special/1-5.jpg'),
  videoClipsSpecialIndex6: require('@/assets/edit/videoClips/special/1-6.jpg'),
  videoClipsSpecialIndex7: require('@/assets/edit/videoClips/special/1-7.jpg'),
  videoClipsSpecialIndex8: require('@/assets/edit/videoClips/special/1-8.jpg'),
  videoClipsSpecialIndex9: require('@/assets/edit/videoClips/special/1-9.jpg'),
  videoClipsSpecialIndex10: require('@/assets/edit/videoClips/special/1-10.jpg'),
  videoClipsSpecialIndex11: require('@/assets/edit/videoClips/special/1-11.jpg'),
  videoClipsSpecialIndex12: require('@/assets/edit/videoClips/special/1-12.jpg'),
  videoClipsSpecialIndex13: require('@/assets/edit/videoClips/special/1-13.jpg'),
  videoClipsSpecialIndex14: require('@/assets/edit/videoClips/special/1-14.jpg'),

  // 视频精剪，主流程图片
  videoEditingPictureIndex2: require('@/assets/edit/videoEditing/picture/1-2.jpg'),
  videoEditingPictureIndex3: require('@/assets/edit/videoEditing/picture/1-3.jpg'),
  videoEditingPictureIndex4: require('@/assets/edit/videoEditing/picture/1-4.jpg'),
  videoEditingPictureIndex5: require('@/assets/edit/videoEditing/picture/1-5.jpg'),
  videoEditingPictureIndex6: require('@/assets/edit/videoEditing/picture/1-6.jpg'),
  videoEditingPictureIndex7: require('@/assets/edit/videoEditing/picture/1-7.jpg'),
  videoEditingPictureIndex8: require('@/assets/edit/videoEditing/picture/1-8.jpg'),
  videoEditingPictureIndex9: require('@/assets/edit/videoEditing/picture/1-9.jpg'),
  videoEditingPictureIndex10: require('@/assets/edit/videoEditing/picture/1-10.jpg'),
  videoEditingPictureIndex11: require('@/assets/edit/videoEditing/picture/1-11.jpg'),
  videoEditingPictureIndex12: require('@/assets/edit/videoEditing/picture/1-12.jpg'),
  videoEditingPictureIndex13: require('@/assets/edit/videoEditing/picture/1-13.jpg'),
  videoEditingPictureIndex14: require('@/assets/edit/videoEditing/picture/1-14.jpg'),
  videoEditingPictureIndex15: require('@/assets/edit/videoEditing/picture/1-15.jpg'),
  videoEditingPictureIndex16: require('@/assets/edit/videoEditing/picture/1-16.jpg'),
  videoEditingPictureIndex17: require('@/assets/edit/videoEditing/picture/1-17.jpg'),
  videoEditingPictureIndex18: require('@/assets/edit/videoEditing/picture/1-18.jpg'),

  videoEditingKeyframeIndex2: require('@/assets/edit/videoEditing/keyframe/1-2.jpg'),
  videoEditingKeyframeIndex3: require('@/assets/edit/videoEditing/keyframe/1-3.jpg'),
  videoEditingKeyframeIndex4: require('@/assets/edit/videoEditing/keyframe/1-4.jpg'),
  videoEditingKeyframeIndex5: require('@/assets/edit/videoEditing/keyframe/1-5.jpg'),
  videoEditingKeyframeIndex6: require('@/assets/edit/videoEditing/keyframe/1-6.jpg'),
  videoEditingKeyframeIndex7: require('@/assets/edit/videoEditing/keyframe/1-7.jpg'),
  videoEditingKeyframeIndex8: require('@/assets/edit/videoEditing/keyframe/1-8.jpg'),
  videoEditingKeyframeIndex9: require('@/assets/edit/videoEditing/keyframe/1-9.jpg'),
  videoEditingKeyframeIndex10: require('@/assets/edit/videoEditing/keyframe/1-10.jpg'),
  videoEditingKeyframeIndex11: require('@/assets/edit/videoEditing/keyframe/1-11.jpg'),
  videoEditingKeyframeIndex12: require('@/assets/edit/videoEditing/keyframe/1-12.jpg'),
  videoEditingKeyframeIndex13: require('@/assets/edit/videoEditing/keyframe/1-13.jpg'),
  videoEditingKeyframeIndex14: require('@/assets/edit/videoEditing/keyframe/1-14.jpg'),
  videoEditingKeyframeIndex15: require('@/assets/edit/videoEditing/keyframe/1-15.jpg'),
  videoEditingKeyframeIndex16: require('@/assets/edit/videoEditing/keyframe/1-16.jpg'),
  videoEditingKeyframeIndex17: require('@/assets/edit/videoEditing/keyframe/1-17.jpg'),
  videoEditingKeyframeIndex18: require('@/assets/edit/videoEditing/keyframe/1-18.jpg'),

  // 快速拼图，主流程图片
  pictureIndex2: require('@/assets/edit/picture/1-2.jpg'),
  pictureIndex3: require('@/assets/edit/picture/1-3.jpg'),
  pictureIndex4: require('@/assets/edit/picture/1-4.jpg'),
  pictureIndex5: require('@/assets/edit/picture/1-5.jpg'),
  pictureIndex6: require('@/assets/edit/picture/1-6.jpg'),
  pictureIndex7: require('@/assets/edit/picture/1-7.jpg'),
  pictureIndex8: require('@/assets/edit/picture/1-8.jpg'),

  // 景物调色，主流程图片
  toningJyIndex2: require('@/assets/edit/toning/jy/1-2.jpg'),
  toningJyIndex3: require('@/assets/edit/toning/jy/1-3.jpg'),
  toningJyIndex4: require('@/assets/edit/toning/jy/1-4.jpg'),
  toningJyIndex5: require('@/assets/edit/toning/jy/1-5.jpg'),
  toningJyIndex6: require('@/assets/edit/toning/jy/1-6.jpg'),
  toningJyIndex7: require('@/assets/edit/toning/jy/1-7.jpg'),
  toningJyIndex8: require('@/assets/edit/toning/jy/1-8.jpg'),
  toningJyIndex9: require('@/assets/edit/toning/jy/1-9.jpg'),
  toningJyIndex10: require('@/assets/edit/toning/jy/1-10.jpg'),
  toningJyIndex11: require('@/assets/edit/toning/jy/1-11.jpg'),
  toningJyIndex12: require('@/assets/edit/toning/jy/1-12.jpg'),
  toningJyIndex13: require('@/assets/edit/toning/jy/1-13.jpg'),
  toningJyIndex14: require('@/assets/edit/toning/jy/1-14.jpg'),
  toningJyIndex15: require('@/assets/edit/toning/jy/1-15.jpg'),
  toningJyIndex16: require('@/assets/edit/toning/jy/1-16.jpg'),
  toningJyIndex17: require('@/assets/edit/toning/jy/1-17.jpg'),
  toningJyIndex18: require('@/assets/edit/toning/jy/1-18.jpg'),
  toningJyIndex19: require('@/assets/edit/toning/jy/1-19.jpg'),

  toningXtIndex2: require('@/assets/edit/toning/xt/1-2.jpg'),
  toningXtIndex3: require('@/assets/edit/toning/xt/1-3.jpg'),
  toningXtIndex4: require('@/assets/edit/toning/xt/1-4.jpg'),
  toningXtIndex5: require('@/assets/edit/toning/xt/1-5.jpg'),
  toningXtIndex6: require('@/assets/edit/toning/xt/1-6.jpg'),
  toningXtIndex7: require('@/assets/edit/toning/xt/1-7.jpg'),
  toningXtIndex8: require('@/assets/edit/toning/xt/1-8.jpg'),
  toningXtIndex9: require('@/assets/edit/toning/xt/1-9.jpg'),
  toningXtIndex10: require('@/assets/edit/toning/xt/1-10.jpg'),
  toningXtIndex11: require('@/assets/edit/toning/xt/1-11.jpg'),
  toningXtIndex12: require('@/assets/edit/toning/xt/1-12.jpg'),
  toningXtIndex13: require('@/assets/edit/toning/xt/1-13.jpg'),
  toningXtIndex14: require('@/assets/edit/toning/xt/1-14.jpg'),
  toningXtIndex15: require('@/assets/edit/toning/xt/1-15.jpg'),

  // 智能监控，主流程图片
  monitorIndex2: require('@/assets/smartLife/monitor/1-2.jpg'),
  monitorIndex3: require('@/assets/smartLife/monitor/1-3.jpg'),
  monitorIndex4: require('@/assets/smartLife/monitor/1-4.jpg'),
  monitorIndex5: require('@/assets/smartLife/monitor/1-5.jpg'),
  monitorIndex6: require('@/assets/smartLife/monitor/1-6.jpg'),
  monitorIndex7: require('@/assets/smartLife/monitor/1-7.jpg'),
  monitorIndex8: require('@/assets/smartLife/monitor/1-8.jpg'),

  // 智能锁，主流程图片
  lockIndex2: require('@/assets/smartLife/lock/1-2.jpg'),
  lockIndex3: require('@/assets/smartLife/lock/1-3.jpg'),
  lockIndex4: require('@/assets/smartLife/lock/1-4.jpg'),
  lockIndex5: require('@/assets/smartLife/lock/1-5.jpg'),
  lockIndex6: require('@/assets/smartLife/lock/1-6.jpg'),
  lockIndex7: require('@/assets/smartLife/lock/1-7.jpg'),
  lockIndex8: require('@/assets/smartLife/lock/1-8.jpg'),
  lockIndex9: require('@/assets/smartLife/lock/1-9.jpg'),
  lockIndex10: require('@/assets/smartLife/lock/1-10.jpg'),

  // AI艺术创作，主流程图片
  createJmIndex2: require('@/assets/smartLife/create/jm/1-2.jpg'),
  createJmIndex3: require('@/assets/smartLife/create/jm/1-3.jpg'),
  createJmIndex4: require('@/assets/smartLife/create/jm/1-4.jpg'),
  createJmIndex5: require('@/assets/smartLife/create/jm/1-5.jpg'),
  createJmIndex6: require('@/assets/smartLife/create/jm/1-6.jpg'),
  createJmIndex7: require('@/assets/smartLife/create/jm/1-7.jpg'),
  createJmIndex8: require('@/assets/smartLife/create/jm/1-8.jpg'),
  createJmIndex9: require('@/assets/smartLife/create/jm/1-9.jpg'),

  branch1CreateJmIndex1: require('@/assets/smartLife/create/jm/2-1.jpg'),
  branch1CreateJmIndex2: require('@/assets/smartLife/create/jm/2-2.jpg'),
  branch1CreateJmIndex3: require('@/assets/smartLife/create/jm/2-3.jpg'),
  branch1CreateJmIndex4: require('@/assets/smartLife/create/jm/2-4.jpg'),
  branch1CreateJmIndex5: require('@/assets/smartLife/create/jm/2-5.jpg'),
  branch1CreateJmIndex6: require('@/assets/smartLife/create/jm/2-6.jpg'),
  branch1CreateJmIndex7: require('@/assets/smartLife/create/jm/2-7.jpg'),
  branch1CreateJmIndex8: require('@/assets/smartLife/create/jm/2-8.jpg'),

  branch2CreateJmIndex1: require('@/assets/smartLife/create/jm/3-1.jpg'),
  branch2CreateJmIndex2: require('@/assets/smartLife/create/jm/3-2.jpg'),
  branch2CreateJmIndex3: require('@/assets/smartLife/create/jm/3-3.jpg'),
  branch2CreateJmIndex4: require('@/assets/smartLife/create/jm/3-4.jpg'),
  branch2CreateJmIndex5: require('@/assets/smartLife/create/jm/3-5.jpg'),
  branch2CreateJmIndex6: require('@/assets/smartLife/create/jm/3-6.jpg'),
  branch2CreateJmIndex7: require('@/assets/smartLife/create/jm/3-7.jpg'),

  createDbIndex2: require('@/assets/smartLife/create/db/1-2.jpg'),
  createDbIndex3: require('@/assets/smartLife/create/db/1-3.jpg'),
  createDbIndex4: require('@/assets/smartLife/create/db/1-4.jpg'),
  createDbIndex5: require('@/assets/smartLife/create/db/1-5.jpg'),
  createDbIndex6: require('@/assets/smartLife/create/db/1-6.jpg'),
  createDbIndex7: require('@/assets/smartLife/create/db/1-7.jpg'),
  createDbIndex8: require('@/assets/smartLife/create/db/1-8.jpg'),
  createDbIndex9: require('@/assets/smartLife/create/db/1-9.jpg'),
  createDbIndex10: require('@/assets/smartLife/create/db/1-10.jpg'),
  createDbIndex11: require('@/assets/smartLife/create/db/1-11.jpg'),
  createDbIndex12: require('@/assets/smartLife/create/db/1-12.jpg'),
  createDbIndex13: require('@/assets/smartLife/create/db/1-13.jpg'),
  createDbIndex14: require('@/assets/smartLife/create/db/1-14.jpg'),
  createDbIndex15: require('@/assets/smartLife/create/db/1-15.jpg'),
  createDbIndex16: require('@/assets/smartLife/create/db/1-16.jpg'),
  createDbIndex17: require('@/assets/smartLife/create/db/1-17.jpg'),
  createDbIndex18: require('@/assets/smartLife/create/db/1-18.jpg'),
  createDbIndex19: require('@/assets/smartLife/create/db/1-19.jpg'),
  createDbIndex20: require('@/assets/smartLife/create/db/1-20.jpg'),
  createDbIndex21: require('@/assets/smartLife/create/db/1-21.jpg'),
  createDbIndex22: require('@/assets/smartLife/create/db/1-22.jpg'),
  createDbIndex23: require('@/assets/smartLife/create/db/1-23.jpg'),
  createDbIndex24: require('@/assets/smartLife/create/db/1-24.jpg'),
  createDbIndex25: require('@/assets/smartLife/create/db/1-25.jpg'),
  createDbIndex26: require('@/assets/smartLife/create/db/1-26.jpg'),
  createDbIndex27: require('@/assets/smartLife/create/db/1-27.jpg'),
  createDbIndex28: require('@/assets/smartLife/create/db/1-28.jpg'),
  createDbIndex29: require('@/assets/smartLife/create/db/1-29.jpg'),

  // 开直播，主流程图片
  liveBroadcastDyIndex2: require('@/assets/entertainment/liveBroadcast/dy/1-2.jpg'),
  liveBroadcastDyIndex3: require('@/assets/entertainment/liveBroadcast/dy/1-3.jpg'),
  liveBroadcastDyIndex4: require('@/assets/entertainment/liveBroadcast/dy/1-4.jpg'),
  liveBroadcastDyIndex5: require('@/assets/entertainment/liveBroadcast/dy/1-5.jpg'),
  liveBroadcastDyIndex6: require('@/assets/entertainment/liveBroadcast/dy/1-6.jpg'),
  liveBroadcastDyIndex7: require('@/assets/entertainment/liveBroadcast/dy/1-7.jpg'),
  liveBroadcastDyIndex8: require('@/assets/entertainment/liveBroadcast/dy/1-8.jpg'),
  liveBroadcastDyIndex9: require('@/assets/entertainment/liveBroadcast/dy/1-9.jpg'),
  liveBroadcastDyIndex10: require('@/assets/entertainment/liveBroadcast/dy/1-10.jpg'),
  liveBroadcastDyIndex11: require('@/assets/entertainment/liveBroadcast/dy/1-11.jpg'),
  liveBroadcastDyIndex12: require('@/assets/entertainment/liveBroadcast/dy/1-12.jpg'),

  branch1LiveBroadcastDyIndex1: require('@/assets/entertainment/liveBroadcast/dy/2-1.jpg'),
  branch1LiveBroadcastDyIndex2: require('@/assets/entertainment/liveBroadcast/dy/2-2.jpg'),
  branch1LiveBroadcastDyIndex3: require('@/assets/entertainment/liveBroadcast/dy/2-3.jpg'),
  branch1LiveBroadcastDyIndex4: require('@/assets/entertainment/liveBroadcast/dy/2-4.jpg'),

  branch2LiveBroadcastDyIndex1: require('@/assets/entertainment/liveBroadcast/dy/3-1.jpg'),
  branch2LiveBroadcastDyIndex2: require('@/assets/entertainment/liveBroadcast/dy/3-2.jpg'),
  branch2LiveBroadcastDyIndex3: require('@/assets/entertainment/liveBroadcast/dy/3-3.jpg'),
  branch2LiveBroadcastDyIndex4: require('@/assets/entertainment/liveBroadcast/dy/3-4.jpg'),
  branch2LiveBroadcastDyIndex5: require('@/assets/entertainment/liveBroadcast/dy/3-5.jpg'),
  branch2LiveBroadcastDyIndex6: require('@/assets/entertainment/liveBroadcast/dy/3-6.jpg'),

  liveBroadcastWxIndex2: require('@/assets/entertainment/liveBroadcast/wx/1-2.jpg'),
  liveBroadcastWxIndex3: require('@/assets/entertainment/liveBroadcast/wx/1-3.jpg'),
  liveBroadcastWxIndex4: require('@/assets/entertainment/liveBroadcast/wx/1-4.jpg'),
  liveBroadcastWxIndex5: require('@/assets/entertainment/liveBroadcast/wx/1-5.jpg'),
  liveBroadcastWxIndex6: require('@/assets/entertainment/liveBroadcast/wx/1-6.jpg'),
  liveBroadcastWxIndex7: require('@/assets/entertainment/liveBroadcast/wx/1-7.jpg'),
  liveBroadcastWxIndex8: require('@/assets/entertainment/liveBroadcast/wx/1-8.jpg'),
  liveBroadcastWxIndex9: require('@/assets/entertainment/liveBroadcast/wx/1-9.jpg'),
  liveBroadcastWxIndex10: require('@/assets/entertainment/liveBroadcast/wx/1-10.jpg'),
  liveBroadcastWxIndex11: require('@/assets/entertainment/liveBroadcast/wx/1-11.jpg'),
  liveBroadcastWxIndex12: require('@/assets/entertainment/liveBroadcast/wx/1-12.jpg'),
  liveBroadcastWxIndex13: require('@/assets/entertainment/liveBroadcast/wx/1-13.jpg'),
  liveBroadcastWxIndex14: require('@/assets/entertainment/liveBroadcast/wx/1-14.jpg'),
  liveBroadcastWxIndex15: require('@/assets/entertainment/liveBroadcast/wx/1-15.jpg'),
  liveBroadcastWxIndex16: require('@/assets/entertainment/liveBroadcast/wx/1-16.jpg'),
  liveBroadcastWxIndex17: require('@/assets/entertainment/liveBroadcast/wx/1-17.jpg'),
  liveBroadcastWxIndex18: require('@/assets/entertainment/liveBroadcast/wx/1-18.jpg'),
  liveBroadcastWxIndex19: require('@/assets/entertainment/liveBroadcast/wx/1-19.jpg'),

  branch1LiveBroadcastWxIndex1: require('@/assets/entertainment/liveBroadcast/wx/2-1.jpg'),
  branch1LiveBroadcastWxIndex2: require('@/assets/entertainment/liveBroadcast/wx/2-2.jpg'),
  branch1LiveBroadcastWxIndex3: require('@/assets/entertainment/liveBroadcast/wx/2-3.jpg'),
  branch1LiveBroadcastWxIndex4: require('@/assets/entertainment/liveBroadcast/wx/2-4.jpg'),
  branch1LiveBroadcastWxIndex5: require('@/assets/entertainment/liveBroadcast/wx/2-5.jpg'),

  branch2LiveBroadcastWxIndex1: require('@/assets/entertainment/liveBroadcast/wx/3-1.jpg'),
  branch2LiveBroadcastWxIndex2: require('@/assets/entertainment/liveBroadcast/wx/3-2.jpg'),
  branch2LiveBroadcastWxIndex3: require('@/assets/entertainment/liveBroadcast/wx/3-3.jpg'),
  branch2LiveBroadcastWxIndex4: require('@/assets/entertainment/liveBroadcast/wx/3-4.jpg'),
  branch2LiveBroadcastWxIndex5: require('@/assets/entertainment/liveBroadcast/wx/3-5.jpg'),
  branch2LiveBroadcastWxIndex6: require('@/assets/entertainment/liveBroadcast/wx/3-6.jpg'),
  branch2LiveBroadcastWxIndex7: require('@/assets/entertainment/liveBroadcast/wx/3-7.jpg'),
  branch2LiveBroadcastWxIndex8: require('@/assets/entertainment/liveBroadcast/wx/3-8.jpg'),
  branch2LiveBroadcastWxIndex9: require('@/assets/entertainment/liveBroadcast/wx/3-9.jpg'),
  branch2LiveBroadcastWxIndex10: require('@/assets/entertainment/liveBroadcast/wx/3-10.jpg'),

  branch3LiveBroadcastWxIndex1: require('@/assets/entertainment/liveBroadcast/wx/4-1.jpg'),
  branch3LiveBroadcastWxIndex2: require('@/assets/entertainment/liveBroadcast/wx/4-2.jpg'),
  branch3LiveBroadcastWxIndex3: require('@/assets/entertainment/liveBroadcast/wx/4-3.jpg'),
  branch3LiveBroadcastWxIndex4: require('@/assets/entertainment/liveBroadcast/wx/4-4.jpg'),

  liveBroadcastXhsIndex2: require('@/assets/entertainment/liveBroadcast/xhs/1-2.jpg'),
  liveBroadcastXhsIndex3: require('@/assets/entertainment/liveBroadcast/xhs/1-3.jpg'),
  liveBroadcastXhsIndex4: require('@/assets/entertainment/liveBroadcast/xhs/1-4.jpg'),
  liveBroadcastXhsIndex5: require('@/assets/entertainment/liveBroadcast/xhs/1-5.jpg'),
  liveBroadcastXhsIndex6: require('@/assets/entertainment/liveBroadcast/xhs/1-6.jpg'),
  liveBroadcastXhsIndex7: require('@/assets/entertainment/liveBroadcast/xhs/1-7.jpg'),
  liveBroadcastXhsIndex8: require('@/assets/entertainment/liveBroadcast/xhs/1-8.jpg'),
  liveBroadcastXhsIndex9: require('@/assets/entertainment/liveBroadcast/xhs/1-9.jpg'),
  liveBroadcastXhsIndex10: require('@/assets/entertainment/liveBroadcast/xhs/1-10.jpg'),
  liveBroadcastXhsIndex11: require('@/assets/entertainment/liveBroadcast/xhs/1-11.jpg'),
  liveBroadcastXhsIndex12: require('@/assets/entertainment/liveBroadcast/xhs/1-12.jpg'),
  liveBroadcastXhsIndex13: require('@/assets/entertainment/liveBroadcast/xhs/1-13.jpg'),
  liveBroadcastXhsIndex14: require('@/assets/entertainment/liveBroadcast/xhs/1-14.jpg'),
  liveBroadcastXhsIndex15: require('@/assets/entertainment/liveBroadcast/xhs/1-15.jpg'),
  liveBroadcastXhsIndex16: require('@/assets/entertainment/liveBroadcast/xhs/1-16.jpg'),

  branch1LiveBroadcastXhsIndex1: require('@/assets/entertainment/liveBroadcast/xhs/2-1.jpg'),
  branch1LiveBroadcastXhsIndex2: require('@/assets/entertainment/liveBroadcast/xhs/2-2.jpg'),
  branch1LiveBroadcastXhsIndex3: require('@/assets/entertainment/liveBroadcast/xhs/2-3.jpg'),
  branch1LiveBroadcastXhsIndex4: require('@/assets/entertainment/liveBroadcast/xhs/2-4.jpg'),
  branch1LiveBroadcastXhsIndex5: require('@/assets/entertainment/liveBroadcast/xhs/2-5.jpg'),
  branch1LiveBroadcastXhsIndex6: require('@/assets/entertainment/liveBroadcast/xhs/2-6.jpg'),
  branch1LiveBroadcastXhsIndex7: require('@/assets/entertainment/liveBroadcast/xhs/2-7.jpg'),
  branch1LiveBroadcastXhsIndex8: require('@/assets/entertainment/liveBroadcast/xhs/2-8.jpg'),

  branch2LiveBroadcastXhsIndex1: require('@/assets/entertainment/liveBroadcast/xhs/3-1.jpg'),
  branch2LiveBroadcastXhsIndex2: require('@/assets/entertainment/liveBroadcast/xhs/3-2.jpg'),
  branch2LiveBroadcastXhsIndex3: require('@/assets/entertainment/liveBroadcast/xhs/3-3.jpg'),
  branch2LiveBroadcastXhsIndex4: require('@/assets/entertainment/liveBroadcast/xhs/3-4.jpg'),

  // 手机K歌，主流程图片
  songKgIndex2: require('@/assets/entertainment/song/kg/1-2.jpg'),
  songKgIndex3: require('@/assets/entertainment/song/kg/1-3.jpg'),
  songKgIndex4: require('@/assets/entertainment/song/kg/1-4.jpg'),
  songKgIndex5: require('@/assets/entertainment/song/kg/1-5.jpg'),
  songKgIndex6: require('@/assets/entertainment/song/kg/1-6.jpg'),
  songKgIndex7: require('@/assets/entertainment/song/kg/1-7.jpg'),
  songKgIndex8: require('@/assets/entertainment/song/kg/1-8.jpg'),
  songKgIndex9: require('@/assets/entertainment/song/kg/1-9.jpg'),
  songKgIndex10: require('@/assets/entertainment/song/kg/1-10.jpg'),
  songKgIndex11: require('@/assets/entertainment/song/kg/1-11.jpg'),
  songKgIndex12: require('@/assets/entertainment/song/kg/1-12.jpg'),
  songKgIndex13: require('@/assets/entertainment/song/kg/1-13.jpg'),
  songKgIndex14: require('@/assets/entertainment/song/kg/1-14.jpg'),
  songKgIndex15: require('@/assets/entertainment/song/kg/1-15.jpg'),

  branchSongKgIndex1: require('@/assets/entertainment/song/kg/2-1.jpg'),
  branchSongKgIndex2: require('@/assets/entertainment/song/kg/2-2.jpg'),
  branchSongKgIndex3: require('@/assets/entertainment/song/kg/2-3.jpg'),
  branchSongKgIndex4: require('@/assets/entertainment/song/kg/2-4.jpg'),
  branchSongKgIndex5: require('@/assets/entertainment/song/kg/2-5.jpg'),
  branchSongKgIndex6: require('@/assets/entertainment/song/kg/2-6.jpg'),
  branchSongKgIndex7: require('@/assets/entertainment/song/kg/2-7.jpg'),

  // 手机听书，主流程图片
  hearXmlyIndex2: require('@/assets/entertainment/hear/xmly/1-2.jpg'),
  hearXmlyIndex3: require('@/assets/entertainment/hear/xmly/1-3.jpg'),
  hearXmlyIndex4: require('@/assets/entertainment/hear/xmly/1-4.jpg'),
  hearXmlyIndex5: require('@/assets/entertainment/hear/xmly/1-5.jpg'),
  hearXmlyIndex6: require('@/assets/entertainment/hear/xmly/1-6.jpg'),
  hearXmlyIndex7: require('@/assets/entertainment/hear/xmly/1-7.jpg'),
  hearXmlyIndex8: require('@/assets/entertainment/hear/xmly/1-8.jpg'),

  branch1HearXmlyIndex2: require('@/assets/entertainment/hear/xmly/2-2.jpg'),
  branch1HearXmlyIndex3: require('@/assets/entertainment/hear/xmly/2-3.jpg'),
  branch1HearXmlyIndex4: require('@/assets/entertainment/hear/xmly/2-4.jpg'),
  branch1HearXmlyIndex5: require('@/assets/entertainment/hear/xmly/2-5.jpg'),
  branch1HearXmlyIndex6: require('@/assets/entertainment/hear/xmly/2-6.jpg'),
  branch1HearXmlyIndex7: require('@/assets/entertainment/hear/xmly/2-7.jpg'),
  branch1HearXmlyIndex8: require('@/assets/entertainment/hear/xmly/2-8.jpg'),
  branch1HearXmlyIndex9: require('@/assets/entertainment/hear/xmly/2-9.jpg'),

  branch2HearXmlyIndex2: require('@/assets/entertainment/hear/xmly/3-2.jpg'),
  branch2HearXmlyIndex3: require('@/assets/entertainment/hear/xmly/3-3.jpg'),
  branch2HearXmlyIndex4: require('@/assets/entertainment/hear/xmly/3-4.jpg'),
  branch2HearXmlyIndex5: require('@/assets/entertainment/hear/xmly/3-5.jpg'),
  branch2HearXmlyIndex6: require('@/assets/entertainment/hear/xmly/3-6.jpg'),
  branch2HearXmlyIndex7: require('@/assets/entertainment/hear/xmly/3-7.jpg'),
  branch2HearXmlyIndex8: require('@/assets/entertainment/hear/xmly/3-8.jpg'),
  branch2HearXmlyIndex9: require('@/assets/entertainment/hear/xmly/3-9.jpg'),
  branch2HearXmlyIndex10: require('@/assets/entertainment/hear/xmly/3-10.jpg'),
  branch2HearXmlyIndex11: require('@/assets/entertainment/hear/xmly/3-11.jpg'),
  branch2HearXmlyIndex12: require('@/assets/entertainment/hear/xmly/3-12.jpg'),
  branch2HearXmlyIndex13: require('@/assets/entertainment/hear/xmly/3-13.jpg'),
  branch2HearXmlyIndex14: require('@/assets/entertainment/hear/xmly/3-14.jpg'),
  branch2HearXmlyIndex15: require('@/assets/entertainment/hear/xmly/3-15.jpg'),

  branch3HearXmlyIndex2: require('@/assets/entertainment/hear/xmly/4-2.jpg'),
  branch3HearXmlyIndex3: require('@/assets/entertainment/hear/xmly/4-3.jpg'),
  branch3HearXmlyIndex4: require('@/assets/entertainment/hear/xmly/4-4.jpg'),
  branch3HearXmlyIndex5: require('@/assets/entertainment/hear/xmly/4-5.jpg'),
  branch3HearXmlyIndex6: require('@/assets/entertainment/hear/xmly/4-6.jpg'),
  branch3HearXmlyIndex7: require('@/assets/entertainment/hear/xmly/4-7.jpg'),
  branch3HearXmlyIndex8: require('@/assets/entertainment/hear/xmly/4-8.jpg'),
  branch3HearXmlyIndex9: require('@/assets/entertainment/hear/xmly/4-9.jpg'),
  branch3HearXmlyIndex10: require('@/assets/entertainment/hear/xmly/4-10.jpg'),
  branch3HearXmlyIndex11: require('@/assets/entertainment/hear/xmly/4-11.jpg'),
  branch3HearXmlyIndex12: require('@/assets/entertainment/hear/xmly/4-12.jpg'),

  hearYtIndex2: require('@/assets/entertainment/hear/yt/1-2.jpg'),
  hearYtIndex3: require('@/assets/entertainment/hear/yt/1-3.jpg'),
  hearYtIndex4: require('@/assets/entertainment/hear/yt/1-4.jpg'),
  hearYtIndex5: require('@/assets/entertainment/hear/yt/1-5.jpg'),
  hearYtIndex6: require('@/assets/entertainment/hear/yt/1-6.jpg'),
  hearYtIndex7: require('@/assets/entertainment/hear/yt/1-7.jpg'),
  hearYtIndex8: require('@/assets/entertainment/hear/yt/1-8.jpg'),
  hearYtIndex9: require('@/assets/entertainment/hear/yt/1-9.jpg'),
  hearYtIndex10: require('@/assets/entertainment/hear/yt/1-10.jpg'),
  hearYtIndex11: require('@/assets/entertainment/hear/yt/1-11.jpg'),
  hearYtIndex12: require('@/assets/entertainment/hear/yt/1-12.jpg'),

  branch1HearYtIndex2: require('@/assets/entertainment/hear/yt/2-2.jpg'),
  branch1HearYtIndex3: require('@/assets/entertainment/hear/yt/2-3.jpg'),
  branch1HearYtIndex4: require('@/assets/entertainment/hear/yt/2-4.jpg'),
  branch1HearYtIndex5: require('@/assets/entertainment/hear/yt/2-5.jpg'),
  branch1HearYtIndex6: require('@/assets/entertainment/hear/yt/2-6.jpg'),
  branch1HearYtIndex7: require('@/assets/entertainment/hear/yt/2-7.jpg'),
  branch1HearYtIndex8: require('@/assets/entertainment/hear/yt/2-8.jpg'),
  branch1HearYtIndex9: require('@/assets/entertainment/hear/yt/2-9.jpg'),

  branch2HearYtIndex2: require('@/assets/entertainment/hear/yt/3-2.jpg'),
  branch2HearYtIndex3: require('@/assets/entertainment/hear/yt/3-3.jpg'),
  branch2HearYtIndex4: require('@/assets/entertainment/hear/yt/3-4.jpg'),
  branch2HearYtIndex5: require('@/assets/entertainment/hear/yt/3-5.jpg'),
  branch2HearYtIndex6: require('@/assets/entertainment/hear/yt/3-6.jpg'),
  branch2HearYtIndex7: require('@/assets/entertainment/hear/yt/3-7.jpg'),
  branch2HearYtIndex8: require('@/assets/entertainment/hear/yt/3-8.jpg'),
  branch2HearYtIndex9: require('@/assets/entertainment/hear/yt/3-9.jpg'),
  branch2HearYtIndex10: require('@/assets/entertainment/hear/yt/3-10.jpg'),
  branch2HearYtIndex11: require('@/assets/entertainment/hear/yt/3-11.jpg'),
  branch2HearYtIndex12: require('@/assets/entertainment/hear/yt/3-12.jpg'),
  branch2HearYtIndex13: require('@/assets/entertainment/hear/yt/3-13.jpg'),
  branch2HearYtIndex14: require('@/assets/entertainment/hear/yt/3-14.jpg'),
  branch2HearYtIndex15: require('@/assets/entertainment/hear/yt/3-15.jpg'),

  branch3HearYtIndex2: require('@/assets/entertainment/hear/yt/4-2.jpg'),
  branch3HearYtIndex3: require('@/assets/entertainment/hear/yt/4-3.jpg'),
  branch3HearYtIndex4: require('@/assets/entertainment/hear/yt/4-4.jpg'),
  branch3HearYtIndex5: require('@/assets/entertainment/hear/yt/4-5.jpg'),
  branch3HearYtIndex6: require('@/assets/entertainment/hear/yt/4-6.jpg'),

  branch4HearYtIndex2: require('@/assets/entertainment/hear/yt/5-2.jpg'),
  branch4HearYtIndex3: require('@/assets/entertainment/hear/yt/5-3.jpg'),
  branch4HearYtIndex4: require('@/assets/entertainment/hear/yt/5-4.jpg'),
  branch4HearYtIndex5: require('@/assets/entertainment/hear/yt/5-5.jpg'),

  // 关注作品，主流程图片
  followWorksDyIndex2: require('@/assets/entertainment/followWorks/dy/1-2.jpg'),
  followWorksDyIndex3: require('@/assets/entertainment/followWorks/dy/1-3.jpg'),
  followWorksDyIndex4: require('@/assets/entertainment/followWorks/dy/1-4.jpg'),
  followWorksDyIndex5: require('@/assets/entertainment/followWorks/dy/1-5.jpg'),
  followWorksDyIndex6: require('@/assets/entertainment/followWorks/dy/1-6.jpg'),
  followWorksDyIndex7: require('@/assets/entertainment/followWorks/dy/1-7.jpg'),
  followWorksDyIndex8: require('@/assets/entertainment/followWorks/dy/1-8.jpg'),
  followWorksDyIndex9: require('@/assets/entertainment/followWorks/dy/1-9.jpg'),
  followWorksDyIndex10: require('@/assets/entertainment/followWorks/dy/1-10.jpg'),
  followWorksDyIndex11: require('@/assets/entertainment/followWorks/dy/1-11.jpg'),

  branchFollowWorksDyIndex2: require('@/assets/entertainment/followWorks/dy/2-2.jpg'),
  branchFollowWorksDyIndex3: require('@/assets/entertainment/followWorks/dy/2-3.jpg'),
  branchFollowWorksDyIndex4: require('@/assets/entertainment/followWorks/dy/2-4.jpg'),
  branchFollowWorksDyIndex5: require('@/assets/entertainment/followWorks/dy/2-5.jpg'),
  branchFollowWorksDyIndex6: require('@/assets/entertainment/followWorks/dy/2-6.jpg'),

  followWorksMpIndex2: require('@/assets/entertainment/followWorks/mp/1-2.jpg'),
  followWorksMpIndex3: require('@/assets/entertainment/followWorks/mp/1-3.jpg'),
  followWorksMpIndex4: require('@/assets/entertainment/followWorks/mp/1-4.jpg'),
  followWorksMpIndex5: require('@/assets/entertainment/followWorks/mp/1-5.jpg'),
  followWorksMpIndex6: require('@/assets/entertainment/followWorks/mp/1-6.jpg'),
  followWorksMpIndex7: require('@/assets/entertainment/followWorks/mp/1-7.jpg'),
  followWorksMpIndex8: require('@/assets/entertainment/followWorks/mp/1-8.jpg'),

  branchFollowWorksMpIndex2: require('@/assets/entertainment/followWorks/mp/2-2.jpg'),
  branchFollowWorksMpIndex3: require('@/assets/entertainment/followWorks/mp/2-3.jpg'),
  branchFollowWorksMpIndex4: require('@/assets/entertainment/followWorks/mp/2-4.jpg'),
  branchFollowWorksMpIndex5: require('@/assets/entertainment/followWorks/mp/2-5.jpg'),
  branchFollowWorksMpIndex6: require('@/assets/entertainment/followWorks/mp/2-6.jpg'),
  branchFollowWorksMpIndex7: require('@/assets/entertainment/followWorks/mp/2-7.jpg'),
  branchFollowWorksMpIndex8: require('@/assets/entertainment/followWorks/mp/2-8.jpg'),
  branchFollowWorksMpIndex9: require('@/assets/entertainment/followWorks/mp/2-9.jpg'),

  followWorksXhsIndex2: require('@/assets/entertainment/followWorks/xhs/1-2.jpg'),
  followWorksXhsIndex3: require('@/assets/entertainment/followWorks/xhs/1-3.jpg'),
  followWorksXhsIndex4: require('@/assets/entertainment/followWorks/xhs/1-4.jpg'),
  followWorksXhsIndex5: require('@/assets/entertainment/followWorks/xhs/1-5.jpg'),
  followWorksXhsIndex6: require('@/assets/entertainment/followWorks/xhs/1-6.jpg'),
  followWorksXhsIndex7: require('@/assets/entertainment/followWorks/xhs/1-7.jpg'),
  followWorksXhsIndex8: require('@/assets/entertainment/followWorks/xhs/1-8.jpg'),
  followWorksXhsIndex9: require('@/assets/entertainment/followWorks/xhs/1-9.jpg'),
  followWorksXhsIndex10: require('@/assets/entertainment/followWorks/xhs/1-10.jpg'),
  followWorksXhsIndex11: require('@/assets/entertainment/followWorks/xhs/1-11.jpg'),
  followWorksXhsIndex12: require('@/assets/entertainment/followWorks/xhs/1-12.jpg'),
  followWorksXhsIndex13: require('@/assets/entertainment/followWorks/xhs/1-13.jpg'),
  followWorksXhsIndex14: require('@/assets/entertainment/followWorks/xhs/1-14.jpg'),

  branchFollowWorksXhsIndex2: require('@/assets/entertainment/followWorks/xhs/2-2.jpg'),
  branchFollowWorksXhsIndex3: require('@/assets/entertainment/followWorks/xhs/2-3.jpg'),
  branchFollowWorksXhsIndex4: require('@/assets/entertainment/followWorks/xhs/2-4.jpg'),
  branchFollowWorksXhsIndex5: require('@/assets/entertainment/followWorks/xhs/2-5.jpg'),
  branchFollowWorksXhsIndex6: require('@/assets/entertainment/followWorks/xhs/2-6.jpg'),
  branchFollowWorksXhsIndex7: require('@/assets/entertainment/followWorks/xhs/2-7.jpg'),
  branchFollowWorksXhsIndex8: require('@/assets/entertainment/followWorks/xhs/2-8.jpg'),

  // 老有所学，主流程图片
  oldStudyIndex1: require('@/assets/study/oldStudy/1-1.jpg'),
  oldStudyIndex2: require('@/assets/study/oldStudy/1-2.jpg'),
  oldStudyIndex3: require('@/assets/study/oldStudy/1-3.jpg'),
  oldStudyIndex4: require('@/assets/study/oldStudy/1-4.jpg'),
  oldStudyIndex5: require('@/assets/study/oldStudy/1-5.jpg'),
  oldStudyIndex6: require('@/assets/study/oldStudy/1-6.jpg'),
  oldStudyIndex7: require('@/assets/study/oldStudy/1-7.jpg'),
  oldStudyIndex8: require('@/assets/study/oldStudy/1-8.jpg'),
  oldStudyIndex9: require('@/assets/study/oldStudy/1-9.jpg'),
  oldStudyIndex10: require('@/assets/study/oldStudy/1-10.jpg'),
  oldStudyIndex11: require('@/assets/study/oldStudy/1-11.jpg'),
  oldStudyIndex12: require('@/assets/study/oldStudy/1-12.jpg'),
  oldStudyIndex13: require('@/assets/study/oldStudy/1-13.jpg'),
  oldStudyIndex14: require('@/assets/study/oldStudy/1-14.jpg'),

  // 名师讲坛，主流程图片
  forumIndex5: require('@/assets/study/forum/1-5.jpg'),
  forumIndex6: require('@/assets/study/forum/1-6.jpg'),
  forumIndex7: require('@/assets/study/forum/1-7.jpg'),
  forumIndex8: require('@/assets/study/forum/1-8.jpg'),
  forumIndex9: require('@/assets/study/forum/1-9.jpg'),
  forumIndex10: require('@/assets/study/forum/1-10.jpg'),
  forumIndex11: require('@/assets/study/forum/1-11.jpg'),
  forumIndex12: require('@/assets/study/forum/1-12.jpg'),
  forumIndex13: require('@/assets/study/forum/1-13.jpg'),
  forumIndex14: require('@/assets/study/forum/1-14.jpg'),
  forumIndex15: require('@/assets/study/forum/1-15.jpg'),
  forumIndex16: require('@/assets/study/forum/1-16.jpg'),
  forumIndex17: require('@/assets/study/forum/1-17.jpg'),
  forumIndex18: require('@/assets/study/forum/1-18.jpg'),
  forumIndex19: require('@/assets/study/forum/1-19.jpg'),

  // 视频课程，主流程图片
  courseIndex5: require('@/assets/study/course/1-5.jpg'),
  courseIndex6: require('@/assets/study/course/1-6.jpg'),
  courseIndex7: require('@/assets/study/course/1-7.jpg'),
  courseIndex8: require('@/assets/study/course/1-8.jpg'),
  courseIndex9: require('@/assets/study/course/1-9.jpg'),
  courseIndex10: require('@/assets/study/course/1-10.jpg'),

  // 数字图书馆，主流程图片
  booksIndex5: require('@/assets/study/books/1-5.jpg'),
  booksIndex6: require('@/assets/study/books/1-6.jpg'),
  booksIndex7: require('@/assets/study/books/1-7.jpg'),
  booksIndex8: require('@/assets/study/books/1-8.jpg'),
  booksIndex9: require('@/assets/study/books/1-9.jpg'),
  booksIndex10: require('@/assets/study/books/1-10.jpg'),
  booksIndex11: require('@/assets/study/books/1-11.jpg'),
  booksIndex12: require('@/assets/study/books/1-12.jpg'),
  booksIndex13: require('@/assets/study/books/1-13.jpg'),
  booksIndex14: require('@/assets/study/books/1-14.jpg'),
  booksIndex15: require('@/assets/study/books/1-15.jpg'),
  booksIndex16: require('@/assets/study/books/1-16.jpg'),
  booksIndex17: require('@/assets/study/books/1-17.jpg'),

  // 我学我秀，主流程图片
  learnShowIndex5: require('@/assets/study/learnShow/1-5.jpg'),
  learnShowIndex6: require('@/assets/study/learnShow/1-6.jpg'),
  learnShowIndex7: require('@/assets/study/learnShow/1-7.jpg'),
  learnShowIndex8: require('@/assets/study/learnShow/1-8.jpg'),
  learnShowIndex9: require('@/assets/study/learnShow/1-9.jpg'),
  learnShowIndex10: require('@/assets/study/learnShow/1-10.jpg'),
  learnShowIndex11: require('@/assets/study/learnShow/1-11.jpg'),

  // 课程学习，主流程图片
  courseLearningIndex1: require('@/assets/study/courseLearning/1-1.jpg'),
  courseLearningIndex2: require('@/assets/study/courseLearning/1-2.jpg'),
  courseLearningIndex3: require('@/assets/study/courseLearning/1-3.jpg'),
  courseLearningIndex4: require('@/assets/study/courseLearning/1-4.jpg'),
  courseLearningIndex5: require('@/assets/study/courseLearning/1-5.jpg'),
  courseLearningIndex6: require('@/assets/study/courseLearning/1-6.jpg'),
  courseLearningIndex7: require('@/assets/study/courseLearning/1-7.jpg'),
  courseLearningIndex8: require('@/assets/study/courseLearning/1-8.jpg'),
  courseLearningIndex9: require('@/assets/study/courseLearning/1-9.jpg'),
  courseLearningIndex10: require('@/assets/study/courseLearning/1-10.jpg'),
  courseLearningIndex11: require('@/assets/study/courseLearning/1-11.jpg'),

  // 国家开放大学，国医名师
  countryCourse1Index2: require('@/assets/study/country/course1/1-2.jpg'),
  countryCourse1Index3: require('@/assets/study/country/course1/1-3.jpg'),
  countryCourse1Index4: require('@/assets/study/country/course1/1-4.jpg'),
  countryCourse1Index5: require('@/assets/study/country/course1/1-5.jpg'),
  countryCourse1Index6: require('@/assets/study/country/course1/1-6.jpg'),
  countryCourse1Index7: require('@/assets/study/country/course1/1-7.jpg'),
  countryCourse1Index8: require('@/assets/study/country/course1/1-8.jpg'),
  countryCourse1Index9: require('@/assets/study/country/course1/1-9.jpg'),
  countryCourse1Index10: require('@/assets/study/country/course1/1-10.jpg'),
  countryCourse1Index11: require('@/assets/study/country/course1/1-11.jpg'),
  countryCourse1Index12: require('@/assets/study/country/course1/1-12.jpg'),
  countryCourse1Index13: require('@/assets/study/country/course1/1-13.jpg'),
  countryCourse1Index14: require('@/assets/study/country/course1/1-14.jpg'),
  countryCourse1Index15: require('@/assets/study/country/course1/1-15.jpg'),
  countryCourse1Index16: require('@/assets/study/country/course1/1-16.jpg'),

  // 国家开放大学，课程超市
  countryCourse2Index2: require('@/assets/study/country/course2/1-2.jpg'),
  countryCourse2Index3: require('@/assets/study/country/course2/1-3.jpg'),
  countryCourse2Index4: require('@/assets/study/country/course2/1-4.jpg'),
  countryCourse2Index5: require('@/assets/study/country/course2/1-5.jpg'),
  countryCourse2Index6: require('@/assets/study/country/course2/1-6.jpg'),
  countryCourse2Index7: require('@/assets/study/country/course2/1-7.jpg'),
  countryCourse2Index8: require('@/assets/study/country/course2/1-8.jpg'),
  countryCourse2Index9: require('@/assets/study/country/course2/1-9.jpg'),
  countryCourse2Index10: require('@/assets/study/country/course2/1-10.jpg'),
  countryCourse2Index11: require('@/assets/study/country/course2/1-11.jpg'),
  countryCourse2Index12: require('@/assets/study/country/course2/1-12.jpg'),
  countryCourse2Index13: require('@/assets/study/country/course2/1-13.jpg'),
  countryCourse2Index14: require('@/assets/study/country/course2/1-14.jpg'),
  countryCourse2Index15: require('@/assets/study/country/course2/1-15.jpg'),
  countryCourse2Index16: require('@/assets/study/country/course2/1-16.jpg'),
  countryCourse2Index17: require('@/assets/study/country/course2/1-17.jpg'),
  countryCourse2Index18: require('@/assets/study/country/course2/1-18.jpg'),
  countryCourse2Index19: require('@/assets/study/country/course2/1-19.jpg'),

  // 国家开放大学，线上学习
  countryCourse3Index2: require('@/assets/study/country/course3/1-2.jpg'),
  countryCourse3Index3: require('@/assets/study/country/course3/1-3.jpg'),
  countryCourse3Index4: require('@/assets/study/country/course3/1-4.jpg'),
  countryCourse3Index5: require('@/assets/study/country/course3/1-5.jpg'),
  countryCourse3Index6: require('@/assets/study/country/course3/1-6.jpg'),
  countryCourse3Index7: require('@/assets/study/country/course3/1-7.jpg'),
  countryCourse3Index8: require('@/assets/study/country/course3/1-8.jpg'),
  countryCourse3Index9: require('@/assets/study/country/course3/1-9.jpg'),
  countryCourse3Index10: require('@/assets/study/country/course3/1-10.jpg'),
  countryCourse3Index11: require('@/assets/study/country/course3/1-11.jpg'),
  countryCourse3Index12: require('@/assets/study/country/course3/1-12.jpg'),
  countryCourse3Index13: require('@/assets/study/country/course3/1-13.jpg'),
  countryCourse3Index14: require('@/assets/study/country/course3/1-14.jpg'),
  countryCourse3Index15: require('@/assets/study/country/course3/1-15.jpg'),
  // 国家开放大学，云课堂
  countryCourse4Index2: require('@/assets/study/country/course4/1-2.jpg'),
  countryCourse4Index3: require('@/assets/study/country/course4/1-3.jpg'),
  countryCourse4Index4: require('@/assets/study/country/course4/1-4.jpg'),
  countryCourse4Index5: require('@/assets/study/country/course4/1-5.jpg'),
  countryCourse4Index6: require('@/assets/study/country/course4/1-6.jpg'),
  countryCourse4Index7: require('@/assets/study/country/course4/1-7.jpg'),
  countryCourse4Index8: require('@/assets/study/country/course4/1-8.jpg'),
  countryCourse4Index9: require('@/assets/study/country/course4/1-9.jpg'),
  countryCourse4Index10: require('@/assets/study/country/course4/1-10.jpg'),
  countryCourse4Index11: require('@/assets/study/country/course4/1-11.jpg'),
  countryCourse4Index12: require('@/assets/study/country/course4/1-12.jpg'),
  countryCourse4Index13: require('@/assets/study/country/course4/1-13.jpg'),
  countryCourse4Index14: require('@/assets/study/country/course4/1-14.jpg'),
  countryCourse4Index15: require('@/assets/study/country/course4/1-15.jpg'),
  countryCourse4Index16: require('@/assets/study/country/course4/1-16.jpg'),
  countryCourse4Index17: require('@/assets/study/country/course4/1-17.jpg'),
  countryCourse4Index18: require('@/assets/study/country/course4/1-18.jpg'),
  countryCourse4Index19: require('@/assets/study/country/course4/1-19.jpg'),

  // 活动参与，主流程图片
  activityParticipationIndex1: require('@/assets/study/activityParticipation/1-1.jpg'),
  activityParticipationIndex2: require('@/assets/study/activityParticipation/1-2.jpg'),
  activityParticipationIndex3: require('@/assets/study/activityParticipation/1-3.jpg'),
  activityParticipationIndex4: require('@/assets/study/activityParticipation/1-4.jpg'),
  activityParticipationIndex5: require('@/assets/study/activityParticipation/1-5.jpg'),
  activityParticipationIndex6: require('@/assets/study/activityParticipation/1-6.jpg'),
  activityParticipationIndex7: require('@/assets/study/activityParticipation/1-7.jpg'),
  activityParticipationIndex8: require('@/assets/study/activityParticipation/1-8.jpg'),
  activityParticipationIndex9: require('@/assets/study/activityParticipation/1-9.jpg'),
  activityParticipationIndex10: require('@/assets/study/activityParticipation/1-10.jpg'),
  activityParticipationIndex11: require('@/assets/study/activityParticipation/1-11.jpg'),

  // 直播观看，主流程图片
  liveStreamingIndex1: require('@/assets/study/liveStreaming/1-1.jpg'),
  liveStreamingIndex2: require('@/assets/study/liveStreaming/1-2.jpg'),
  liveStreamingIndex3: require('@/assets/study/liveStreaming/1-3.jpg'),
  liveStreamingIndex4: require('@/assets/study/liveStreaming/1-4.jpg'),
  liveStreamingIndex5: require('@/assets/study/liveStreaming/1-5.jpg'),
  liveStreamingIndex6: require('@/assets/study/liveStreaming/1-6.jpg'),
  liveStreamingIndex7: require('@/assets/study/liveStreaming/1-7.jpg'),
  liveStreamingIndex8: require('@/assets/study/liveStreaming/1-8.jpg'),
  liveStreamingIndex9: require('@/assets/study/liveStreaming/1-9.jpg'),
  liveStreamingIndex10: require('@/assets/study/liveStreaming/1-10.jpg'),
  liveStreamingIndex11: require('@/assets/study/liveStreaming/1-11.jpg'),

  // 悦听资源，主流程图片
  yuetingResourcesIndex1: require('@/assets/study/yuetingResources/1-1.jpg'),
  yuetingResourcesIndex2: require('@/assets/study/yuetingResources/1-2.jpg'),
  yuetingResourcesIndex3: require('@/assets/study/yuetingResources/1-3.jpg'),
  yuetingResourcesIndex4: require('@/assets/study/yuetingResources/1-4.jpg'),
  yuetingResourcesIndex5: require('@/assets/study/yuetingResources/1-5.jpg'),
  yuetingResourcesIndex6: require('@/assets/study/yuetingResources/1-6.jpg'),
  yuetingResourcesIndex7: require('@/assets/study/yuetingResources/1-7.jpg'),

  // 手机买电影票，微信
  filmWxIndex1: require('@/assets/entertainment/film/wx/1-1.jpg'),
  filmWxIndex2: require('@/assets/entertainment/film/wx/1-2.jpg'),
  filmWxIndex3: require('@/assets/entertainment/film/wx/1-3.jpg'),
  filmWxIndex4: require('@/assets/entertainment/film/wx/1-4.jpg'),
  filmWxIndex5: require('@/assets/entertainment/film/wx/1-5.jpg'),
  filmWxIndex6: require('@/assets/entertainment/film/wx/1-6.jpg'),
  filmWxIndex7: require('@/assets/entertainment/film/wx/1-7.jpg'),
  filmWxIndex8: require('@/assets/entertainment/film/wx/1-8.jpg'),
  filmWxIndex9: require('@/assets/entertainment/film/wx/1-9.jpg'),
  filmWxIndex10: require('@/assets/entertainment/film/wx/1-10.jpg'),
  filmWxIndex11: require('@/assets/entertainment/film/wx/1-11.jpg'),
  filmWxIndex12: require('@/assets/entertainment/film/wx/1-12.jpg'),
  filmWxIndex13: require('@/assets/entertainment/film/wx/1-13.jpg'),
  filmWxIndex14: require('@/assets/entertainment/film/wx/1-14.jpg'),
  filmWxIndex15: require('@/assets/entertainment/film/wx/1-15.jpg'),
  filmWxIndex16: require('@/assets/entertainment/film/wx/1-16.jpg'),
  filmWxIndex17: require('@/assets/entertainment/film/wx/1-17.jpg'),
  filmWxIndex18: require('@/assets/entertainment/film/wx/2-1.jpg'),
  filmWxIndex19: require('@/assets/entertainment/film/wx/2-2.jpg'),
  filmWxIndex20: require('@/assets/entertainment/film/wx/2-3.jpg'),
  filmWxIndex21: require('@/assets/entertainment/film/wx/2-4.jpg'),
  filmWxIndex22: require('@/assets/entertainment/film/wx/2-5.jpg'),
  filmWxIndex23: require('@/assets/entertainment/film/wx/2-6.jpg'),
  filmWxIndex24: require('@/assets/entertainment/film/wx/2-7.jpg'),

  // 手机买电影票，支付宝
  // filmZfbIndex1: require('@/assets/entertainment/film/zfb/1-1.jpg'),
  filmZfbIndex2: require('@/assets/entertainment/film/zfb/1-2.jpg'),
  filmZfbIndex3: require('@/assets/entertainment/film/zfb/1-3.jpg'),
  filmZfbIndex4: require('@/assets/entertainment/film/zfb/1-4.jpg'),
  filmZfbIndex5: require('@/assets/entertainment/film/zfb/1-5.jpg'),
  filmZfbIndex6: require('@/assets/entertainment/film/zfb/1-6.jpg'),
  filmZfbIndex7: require('@/assets/entertainment/film/zfb/1-7.jpg'),
  filmZfbIndex8: require('@/assets/entertainment/film/zfb/1-8.jpg'),
  filmZfbIndex9: require('@/assets/entertainment/film/zfb/1-9.jpg'),
  filmZfbIndex10: require('@/assets/entertainment/film/zfb/1-10.jpg'),
  filmZfbIndex11: require('@/assets/entertainment/film/zfb/1-11.jpg'),
  filmZfbIndex12: require('@/assets/entertainment/film/zfb/1-12.jpg'),
  filmZfbIndex13: require('@/assets/entertainment/film/zfb/1-13.jpg'),
  filmZfbIndex14: require('@/assets/entertainment/film/zfb/1-14.jpg'),
  filmZfbIndex15: require('@/assets/entertainment/film/zfb/1-15.jpg'),
  filmZfbIndex16: require('@/assets/entertainment/film/zfb/1-16.jpg'),
  filmZfbIndex17: require('@/assets/entertainment/film/zfb/1-17.jpg'),
  filmZfbIndex18: require('@/assets/entertainment/film/zfb/2-1.jpg'),
  filmZfbIndex19: require('@/assets/entertainment/film/zfb/2-2.jpg'),
  filmZfbIndex20: require('@/assets/entertainment/film/zfb/2-3.jpg'),
  filmZfbIndex21: require('@/assets/entertainment/film/zfb/2-4.jpg'),
  filmZfbIndex28: require('@/assets/entertainment/film/zfb/2-5.jpg'),
  filmZfbIndex22: require('@/assets/entertainment/film/zfb/2-6.jpg'),
  filmZfbIndex23: require('@/assets/entertainment/film/zfb/2-7.jpg'),
  filmZfbIndex24: require('@/assets/entertainment/film/zfb/2-8.jpg'),
  filmZfbIndex25: require('@/assets/entertainment/film/zfb/2-9.jpg'),
  filmZfbIndex26: require('@/assets/entertainment/film/zfb/2-10.jpg'),
  filmZfbIndex27: require('@/assets/entertainment/film/zfb/2-11.jpg'),

  // 发布作品 抖音
  publishWorksDyIndex2: require('@/assets/entertainment/publishWorks/dy/1-2.jpg'),
  publishWorksDyIndex3: require('@/assets/entertainment/publishWorks/dy/1-3.jpg'),
  publishWorksDyIndex4: require('@/assets/entertainment/publishWorks/dy/1-4.jpg'),
  publishWorksDyIndex5: require('@/assets/entertainment/publishWorks/dy/1-5.jpg'),
  publishWorksDyIndex6: require('@/assets/entertainment/publishWorks/dy/1-6.jpg'),
  publishWorksDyIndex7: require('@/assets/entertainment/publishWorks/dy/1-7.jpg'),
  publishWorksDyIndex8: require('@/assets/entertainment/publishWorks/dy/1-8.jpg'),
  publishWorksDyIndex9: require('@/assets/entertainment/publishWorks/dy/1-9.jpg'),
  publishWorksDyIndex10: require('@/assets/entertainment/publishWorks/dy/1-10.jpg'),
  publishWorksDyIndex11: require('@/assets/entertainment/publishWorks/dy/1-11.jpg'),
  publishWorksDyIndex12: require('@/assets/entertainment/publishWorks/dy/1-12.jpg'),
  publishWorksDyIndex13: require('@/assets/entertainment/publishWorks/dy/1-13.jpg'),
  publishWorksDyIndex14: require('@/assets/entertainment/publishWorks/dy/1-14.jpg'),
  publishWorksDyIndex15: require('@/assets/entertainment/publishWorks/dy/1-15.jpg'),
  publishWorksDyIndex16: require('@/assets/entertainment/publishWorks/dy/2-2.jpg'),
  publishWorksDyIndex17: require('@/assets/entertainment/publishWorks/dy/2-3.jpg'),
  publishWorksDyIndex18: require('@/assets/entertainment/publishWorks/dy/2-4.jpg'),
  publishWorksDyIndex19: require('@/assets/entertainment/publishWorks/dy/2-5.jpg'),
  publishWorksDyIndex20: require('@/assets/entertainment/publishWorks/dy/2-6.jpg'),
  publishWorksDyIndex21: require('@/assets/entertainment/publishWorks/dy/2-7.jpg'),
  publishWorksDyIndex22: require('@/assets/entertainment/publishWorks/dy/2-8.jpg'),
  publishWorksDyIndex23: require('@/assets/entertainment/publishWorks/dy/2-9.jpg'),
  publishWorksDyIndex24: require('@/assets/entertainment/publishWorks/dy/2-10.jpg'),
  publishWorksDyIndex25: require('@/assets/entertainment/publishWorks/dy/2-11.jpg'),
  publishWorksDyIndex26: require('@/assets/entertainment/publishWorks/dy/2-12.jpg'),
  publishWorksDyIndex27: require('@/assets/entertainment/publishWorks/dy/2-13.jpg'),
  publishWorksDyIndex28: require('@/assets/entertainment/publishWorks/dy/2-14.jpg'),
  publishWorksDyIndex29: require('@/assets/entertainment/publishWorks/dy/3-1.jpg'),
  publishWorksDyIndex30: require('@/assets/entertainment/publishWorks/dy/3-2.jpg'),
  publishWorksDyIndex31: require('@/assets/entertainment/publishWorks/dy/3-3.jpg'),
  publishWorksDyIndex32: require('@/assets/entertainment/publishWorks/dy/3-4.jpg'),
  publishWorksDyIndex33: require('@/assets/entertainment/publishWorks/dy/3-5.jpg'),
  publishWorksDyIndex34: require('@/assets/entertainment/publishWorks/dy/3-6.jpg'),
  publishWorksDyIndex35: require('@/assets/entertainment/publishWorks/dy/3-7.jpg'),
  publishWorksDyIndex36: require('@/assets/entertainment/publishWorks/dy/4-1.jpg'),
  publishWorksDyIndex37: require('@/assets/entertainment/publishWorks/dy/4-2.jpg'),
  publishWorksDyIndex38: require('@/assets/entertainment/publishWorks/dy/4-3.jpg'),
  publishWorksDyIndex39: require('@/assets/entertainment/publishWorks/dy/4-4.jpg'),
  publishWorksDyIndex40: require('@/assets/entertainment/publishWorks/dy/4-5.jpg'),

  // 发布作品 美篇
  publishWorksMpIndex1: require('@/assets/entertainment/publishWorks/mp/1-1.png'),
  publishWorksMpIndex2: require('@/assets/entertainment/publishWorks/mp/1-2.jpg'),
  publishWorksMpIndex3: require('@/assets/entertainment/publishWorks/mp/1-3.jpg'),
  publishWorksMpIndex4: require('@/assets/entertainment/publishWorks/mp/1-4.jpg'),
  publishWorksMpIndex5: require('@/assets/entertainment/publishWorks/mp/1-5.jpg'),
  publishWorksMpIndex6: require('@/assets/entertainment/publishWorks/mp/1-6.jpg'),
  publishWorksMpIndex7: require('@/assets/entertainment/publishWorks/mp/1-7.jpg'),
  publishWorksMpIndex8: require('@/assets/entertainment/publishWorks/mp/1-8.jpg'),
  publishWorksMpIndex9: require('@/assets/entertainment/publishWorks/mp/1-9.jpg'),
  publishWorksMpIndex10: require('@/assets/entertainment/publishWorks/mp/1-10.jpg'),
  publishWorksMpIndex11: require('@/assets/entertainment/publishWorks/mp/1-11.jpg'),
  publishWorksMpIndex12: require('@/assets/entertainment/publishWorks/mp/1-12.jpg'),
  publishWorksMpIndex13: require('@/assets/entertainment/publishWorks/mp/1-13.jpg'),
  publishWorksMpIndex14: require('@/assets/entertainment/publishWorks/mp/1-14.jpg'),

  // 发布作品 小红书
  publishWorksXhsIndex1: require('@/assets/entertainment/publishWorks/xhs/1-1.png'),
  publishWorksXhsIndex2: require('@/assets/entertainment/publishWorks/xhs/1-2.jpg'),
  publishWorksXhsIndex3: require('@/assets/entertainment/publishWorks/xhs/1-3.jpg'),
  publishWorksXhsIndex4: require('@/assets/entertainment/publishWorks/xhs/1-4.jpg'),
  publishWorksXhsIndex5: require('@/assets/entertainment/publishWorks/xhs/1-5.jpg'),
  publishWorksXhsIndex6: require('@/assets/entertainment/publishWorks/xhs/1-6.jpg'),
  publishWorksXhsIndex7: require('@/assets/entertainment/publishWorks/xhs/1-7.jpg'),
  publishWorksXhsIndex8: require('@/assets/entertainment/publishWorks/xhs/1-8.jpg'),
  publishWorksXhsIndex9: require('@/assets/entertainment/publishWorks/xhs/1-9.jpg'),
  publishWorksXhsIndex10: require('@/assets/entertainment/publishWorks/xhs/1-10.jpg'),
  publishWorksXhsIndex11: require('@/assets/entertainment/publishWorks/xhs/1-11.jpg'),
  publishWorksXhsIndex12: require('@/assets/entertainment/publishWorks/xhs/1-12.jpg'),

  // AI伙伴 deepseek
  aiDeepSeekIndex2: require('@/assets/smartLife/partner/dp/1-2.jpg'),
  aiDeepSeekIndex3: require('@/assets/smartLife/partner/dp/1-3.jpg'),
  aiDeepSeekIndex4: require('@/assets/smartLife/partner/dp/1-4.jpg'),
  aiDeepSeekIndex5: require('@/assets/smartLife/partner/dp/1-5.jpg'),
  aiDeepSeekIndex6: require('@/assets/smartLife/partner/dp/1-6.jpg'),
  aiDeepSeekIndex7: require('@/assets/smartLife/partner/dp/1-7.jpg'),
  aiDeepSeekIndex8: require('@/assets/smartLife/partner/dp/1-8.jpg'),

  aiDeepSeekIndex12: require('@/assets/smartLife/partner/dp/2-1.jpg'),
  aiDeepSeekIndex13: require('@/assets/smartLife/partner/dp/2-2.jpg'),
  aiDeepSeekIndex14: require('@/assets/smartLife/partner/dp/2-3.jpg'),
  aiDeepSeekIndex15: require('@/assets/smartLife/partner/dp/2-4.jpg'),
  aiDeepSeekIndex16: require('@/assets/smartLife/partner/dp/2-5.jpg'),
  aiDeepSeekIndex17: require('@/assets/smartLife/partner/dp/2-6.jpg'),
  aiDeepSeekIndex18: require('@/assets/smartLife/partner/dp/3-1.jpg'),
  aiDeepSeekIndex19: require('@/assets/smartLife/partner/dp/3-2.jpg'),
  aiDeepSeekIndex20: require('@/assets/smartLife/partner/dp/3-3.jpg'),

  // AI伙伴 豆包
  // aiDbIndex1: require('@/assets/smartLife/partner/db/1-1.jpg'),
  aiDbIndex2: require('@/assets/smartLife/partner/db/1-2.jpg'),
  aiDbIndex3: require('@/assets/smartLife/partner/db/1-3.jpg'),
  aiDbIndex4: require('@/assets/smartLife/partner/db/1-4.jpg'),
  aiDbIndex5: require('@/assets/smartLife/partner/db/1-5.jpg'),
  aiDbIndex6: require('@/assets/smartLife/partner/db/1-6.jpg'),
  aiDbIndex7: require('@/assets/smartLife/partner/db/1-7.jpg'),
  aiDbIndex8: require('@/assets/smartLife/partner/db/1-8.jpg'),

 



  aiDbBranch1Index1: require('@/assets/smartLife/partner/db/2-1.jpg'),
  aiDbBranch1Index2: require('@/assets/smartLife/partner/db/2-2.jpg'),
  aiDbBranch1Index3: require('@/assets/smartLife/partner/db/2-3.jpg'),
  aiDbBranch1Index4: require('@/assets/smartLife/partner/db/2-4.jpg'),
  aiDbBranch1Index5: require('@/assets/smartLife/partner/db/2-5.jpg'),
  aiDbBranch1Index6: require('@/assets/smartLife/partner/db/2-6.jpg'),
  aiDbBranch1Index7: require('@/assets/smartLife/partner/db/2-7.jpg'),
  aiDbBranch1Index8: require('@/assets/smartLife/partner/db/2-8.jpg'),
  aiDbBranch1Index9: require('@/assets/smartLife/partner/db/2-9.jpg'),
  aiDbBranch1Index10: require('@/assets/smartLife/partner/db/2-10.jpg'),
  aiDbBranch1Index11: require('@/assets/smartLife/partner/db/2-11.jpg'),
  aiDbBranch1Index12: require('@/assets/smartLife/partner/db/2-12.jpg'),
  aiDbBranch1Index13: require('@/assets/smartLife/partner/db/2-13.jpg'),
  aiDbBranch1Index14: require('@/assets/smartLife/partner/db/2-14.jpg'),
  aiDbBranch1Index15: require('@/assets/smartLife/partner/db/2-15.jpg'),
  aiDbBranch1Index16: require('@/assets/smartLife/partner/db/2-16.jpg'),
  aiDbBranch1Index17: require('@/assets/smartLife/partner/db/2-17.jpg'),





  // AI伙伴 讯飞
  aiXfIndex1: require('@/assets/smartLife/partner/xf/1-1.jpg'),
  aiXfIndex2: require('@/assets/smartLife/partner/xf/1-2.jpg'),
  aiXfIndex3: require('@/assets/smartLife/partner/xf/1-3.jpg'),
  aiXfIndex4: require('@/assets/smartLife/partner/xf/1-4.jpg'),
  aiXfIndex5: require('@/assets/smartLife/partner/xf/1-5.jpg'),
  aiXfIndex6: require('@/assets/smartLife/partner/xf/1-6.jpg'),
  aiXfIndex7: require('@/assets/smartLife/partner/xf/1-7.jpg'),
  aiXfIndex8: require('@/assets/smartLife/partner/xf/1-8.jpg'),
  aiXfIndex9: require('@/assets/smartLife/partner/xf/1-9.jpg'),
  aiXfIndex10: require('@/assets/smartLife/partner/xf/1-10.jpg'),
  aiXfIndex11: require('@/assets/smartLife/partner/xf/1-11.jpg'),
  aiXfIndex12: require('@/assets/smartLife/partner/xf/1-12.jpg'),
  aiXfIndex13: require('@/assets/smartLife/partner/xf/1-13.jpg'),
  aiXfIndex14: require('@/assets/smartLife/partner/xf/1-14.jpg'),
  aiXfIndex15: require('@/assets/smartLife/partner/xf/1-15.jpg'),
  aiXfIndex16: require('@/assets/smartLife/partner/xf/1-16.jpg'),
  aiXfIndex17: require('@/assets/smartLife/partner/xf/1-17.jpg'),
  aiXfIndex18: require('@/assets/smartLife/partner/xf/1-18.jpg'),
  aiXfIndex19: require('@/assets/smartLife/partner/xf/1-19.jpg'),
  aiXfIndex20: require('@/assets/smartLife/partner/xf/1-20.jpg'),
  aiXfIndex21: require('@/assets/smartLife/partner/xf/1-21.jpg'),
  aiXfIndex22: require('@/assets/smartLife/partner/xf/1-22.jpg'),
  aiXfIndex23: require('@/assets/smartLife/partner/xf/1-23.jpg'),
  aiXfIndex24: require('@/assets/smartLife/partner/xf/1-24.jpg'),
  aiXfIndex25: require('@/assets/smartLife/partner/xf/1-25.jpg'),
  aiXfIndex26: require('@/assets/smartLife/partner/xf/1-26.jpg'),
  aiXfIndex27: require('@/assets/smartLife/partner/xf/1-27.jpg'),
  aiXfIndex28: require('@/assets/smartLife/partner/xf/1-28.jpg'),
  aiXfIndex29: require('@/assets/smartLife/partner/xf/1-29.jpg'),
  aiXfIndex30: require('@/assets/smartLife/partner/xf/2-1.jpg'),
  aiXfIndex31: require('@/assets/smartLife/partner/xf/2-2.jpg'),
  aiXfIndex32: require('@/assets/smartLife/partner/xf/2-3.jpg'),
  aiXfIndex33: require('@/assets/smartLife/partner/xf/2-4.jpg'),
  aiXfIndex34: require('@/assets/smartLife/partner/xf/2-5.jpg'),
  aiXfIndex35: require('@/assets/smartLife/partner/xf/2-6.jpg'),
  aiXfIndex36: require('@/assets/smartLife/partner/xf/2-7.jpg'),
  aiXfIndex37: require('@/assets/smartLife/partner/xf/2-8.jpg'),
  aiXfIndex38: require('@/assets/smartLife/partner/xf/2-9.jpg'),

  // AI生图，豆包
  AIGeneratedImagesDbIndex2: require('@/assets/smartLife/AIGeneratedImages/db/1-2.jpg'),
  AIGeneratedImagesDbIndex3: require('@/assets/smartLife/AIGeneratedImages/db/1-3.jpg'),
  AIGeneratedImagesDbIndex4: require('@/assets/smartLife/AIGeneratedImages/db/1-4.jpg'),
  AIGeneratedImagesDbIndex5: require('@/assets/smartLife/AIGeneratedImages/db/1-5.jpg'),
  AIGeneratedImagesDbIndex6: require('@/assets/smartLife/AIGeneratedImages/db/1-6.jpg'),
  AIGeneratedImagesDbIndex7: require('@/assets/smartLife/AIGeneratedImages/db/1-7.jpg'),
  AIGeneratedImagesDbIndex8: require('@/assets/smartLife/AIGeneratedImages/db/1-8.jpg'),
  AIGeneratedImagesDbIndex9: require('@/assets/smartLife/AIGeneratedImages/db/1-9.jpg'),
  AIGeneratedImagesDbIndex10: require('@/assets/smartLife/AIGeneratedImages/db/1-10.jpg'),
  // AI生图，豆包，分支1
  AIGeneratedImagesDbBranch1Index1: require('@/assets/smartLife/AIGeneratedImages/db/2-1.jpg'),
  AIGeneratedImagesDbBranch1Index2: require('@/assets/smartLife/AIGeneratedImages/db/2-2.jpg'),
  AIGeneratedImagesDbBranch1Index3: require('@/assets/smartLife/AIGeneratedImages/db/2-3.jpg'),
  AIGeneratedImagesDbBranch1Index4: require('@/assets/smartLife/AIGeneratedImages/db/2-4.jpg'),
  AIGeneratedImagesDbBranch1Index5: require('@/assets/smartLife/AIGeneratedImages/db/2-5.jpg'),
  AIGeneratedImagesDbBranch1Index6: require('@/assets/smartLife/AIGeneratedImages/db/2-6.jpg'),
  AIGeneratedImagesDbBranch1Index7: require('@/assets/smartLife/AIGeneratedImages/db/2-7.jpg'),

  // AI生图，即梦
  AIGeneratedImagesJmIndex2: require('@/assets/smartLife/AIGeneratedImages/jm/1-2.jpg'),
  AIGeneratedImagesJmIndex3: require('@/assets/smartLife/AIGeneratedImages/jm/1-3.jpg'),
  AIGeneratedImagesJmIndex4: require('@/assets/smartLife/AIGeneratedImages/jm/1-4.jpg'),
  AIGeneratedImagesJmIndex5: require('@/assets/smartLife/AIGeneratedImages/jm/1-5.jpg'),
  AIGeneratedImagesJmIndex6: require('@/assets/smartLife/AIGeneratedImages/jm/1-6.jpg'),
  AIGeneratedImagesJmIndex7: require('@/assets/smartLife/AIGeneratedImages/jm/1-7.jpg'),
  AIGeneratedImagesJmIndex8: require('@/assets/smartLife/AIGeneratedImages/jm/1-8.jpg'),
  AIGeneratedImagesJmIndex9: require('@/assets/smartLife/AIGeneratedImages/jm/1-9.jpg'),
  AIGeneratedImagesJmIndex10: require('@/assets/smartLife/AIGeneratedImages/jm/1-10.jpg'),
  AIGeneratedImagesJmIndex11: require('@/assets/smartLife/AIGeneratedImages/jm/1-11.jpg'),
  AIGeneratedImagesJmIndex12: require('@/assets/smartLife/AIGeneratedImages/jm/1-12.jpg'),
  // AI生图，即梦，分支1
  AIGeneratedImagesJmBranch1Index1: require('@/assets/smartLife/AIGeneratedImages/jm/2-1.jpg'),
  AIGeneratedImagesJmBranch1Index2: require('@/assets/smartLife/AIGeneratedImages/jm/2-2.jpg'),
  AIGeneratedImagesJmBranch1Index3: require('@/assets/smartLife/AIGeneratedImages/jm/2-3.jpg'),
  AIGeneratedImagesJmBranch1Index4: require('@/assets/smartLife/AIGeneratedImages/jm/2-4.jpg'),

  // AI生视频，豆包
  AIGeneratedVideosDbIndex2: require('@/assets/smartLife/AIGeneratedVideos/db/1-2.jpg'),
  AIGeneratedVideosDbIndex3: require('@/assets/smartLife/AIGeneratedVideos/db/1-3.jpg'),
  AIGeneratedVideosDbIndex4: require('@/assets/smartLife/AIGeneratedVideos/db/1-4.jpg'),
  AIGeneratedVideosDbIndex5: require('@/assets/smartLife/AIGeneratedVideos/db/1-5.jpg'),
  AIGeneratedVideosDbIndex6: require('@/assets/smartLife/AIGeneratedVideos/db/1-6.jpg'),
  AIGeneratedVideosDbIndex7: require('@/assets/smartLife/AIGeneratedVideos/db/1-7.jpg'),
  AIGeneratedVideosDbIndex8: require('@/assets/smartLife/AIGeneratedVideos/db/1-8.jpg'),
  AIGeneratedVideosDbIndex9: require('@/assets/smartLife/AIGeneratedVideos/db/1-9.jpg'),
  AIGeneratedVideosDbIndex10: require('@/assets/smartLife/AIGeneratedVideos/db/1-10.jpg'),
  AIGeneratedVideosDbIndex11: require('@/assets/smartLife/AIGeneratedVideos/db/1-11.jpg'),
  AIGeneratedVideosDbIndex12: require('@/assets/smartLife/AIGeneratedVideos/db/1-12.jpg'),
  AIGeneratedVideosDbIndex13: require('@/assets/smartLife/AIGeneratedVideos/db/1-13.jpg'),
  // AI生视频，豆包，分支1
  AIGeneratedVideosDbBranch1Index1: require('@/assets/smartLife/AIGeneratedVideos/db/2-1.jpg'),
  AIGeneratedVideosDbBranch1Index2: require('@/assets/smartLife/AIGeneratedVideos/db/2-2.jpg'),
  AIGeneratedVideosDbBranch1Index3: require('@/assets/smartLife/AIGeneratedVideos/db/2-3.jpg'),
  AIGeneratedVideosDbBranch1Index4: require('@/assets/smartLife/AIGeneratedVideos/db/2-4.jpg'),
  AIGeneratedVideosDbBranch1Index5: require('@/assets/smartLife/AIGeneratedVideos/db/2-5.jpg'),
  AIGeneratedVideosDbBranch1Index6: require('@/assets/smartLife/AIGeneratedVideos/db/2-6.jpg'),
  AIGeneratedVideosDbBranch1Index7: require('@/assets/smartLife/AIGeneratedVideos/db/2-7.jpg'),
  AIGeneratedVideosDbBranch1Index8: require('@/assets/smartLife/AIGeneratedVideos/db/2-8.jpg'),
  AIGeneratedVideosDbBranch1Index9: require('@/assets/smartLife/AIGeneratedVideos/db/2-9.jpg'),
  AIGeneratedVideosDbBranch1Index10: require('@/assets/smartLife/AIGeneratedVideos/db/2-10.jpg'),

  // AI生视频，即梦
  AIGeneratedVideosJmIndex2: require('@/assets/smartLife/AIGeneratedVideos/jm/1-2.jpg'),
  AIGeneratedVideosJmIndex3: require('@/assets/smartLife/AIGeneratedVideos/jm/1-3.jpg'),
  AIGeneratedVideosJmIndex4: require('@/assets/smartLife/AIGeneratedVideos/jm/1-4.jpg'),
  AIGeneratedVideosJmIndex5: require('@/assets/smartLife/AIGeneratedVideos/jm/1-5.jpg'),
  AIGeneratedVideosJmIndex6: require('@/assets/smartLife/AIGeneratedVideos/jm/1-6.jpg'),
  AIGeneratedVideosJmIndex7: require('@/assets/smartLife/AIGeneratedVideos/jm/1-7.jpg'),
  AIGeneratedVideosJmIndex8: require('@/assets/smartLife/AIGeneratedVideos/jm/1-8.jpg'),
  AIGeneratedVideosJmIndex9: require('@/assets/smartLife/AIGeneratedVideos/jm/1-9.jpg'),
  AIGeneratedVideosJmIndex10: require('@/assets/smartLife/AIGeneratedVideos/jm/1-10.jpg'),
  AIGeneratedVideosJmIndex11: require('@/assets/smartLife/AIGeneratedVideos/jm/1-11.jpg'),
  AIGeneratedVideosJmIndex12: require('@/assets/smartLife/AIGeneratedVideos/jm/1-12.jpg'),
  // AI生视频，即梦，分支1
  AIGeneratedVideosJmBranch1Index1: require('@/assets/smartLife/AIGeneratedVideos/jm/2-1.jpg'),
  AIGeneratedVideosJmBranch1Index2: require('@/assets/smartLife/AIGeneratedVideos/jm/2-2.jpg'),
  AIGeneratedVideosJmBranch1Index3: require('@/assets/smartLife/AIGeneratedVideos/jm/2-3.jpg'),
  AIGeneratedVideosJmBranch1Index4: require('@/assets/smartLife/AIGeneratedVideos/jm/2-4.jpg'),
  AIGeneratedVideosJmBranch1Index5: require('@/assets/smartLife/AIGeneratedVideos/jm/2-5.jpg'),
  AIGeneratedVideosJmBranch1Index6: require('@/assets/smartLife/AIGeneratedVideos/jm/2-6.jpg'),
  AIGeneratedVideosJmBranch1Index7: require('@/assets/smartLife/AIGeneratedVideos/jm/2-7.jpg'),

  // AI写真，豆包
  AIPhotographyDbIndex2: require('@/assets/smartLife/AIPhotography/db/1-2.jpg'),
  AIPhotographyDbIndex3: require('@/assets/smartLife/AIPhotography/db/1-3.jpg'),
  AIPhotographyDbIndex4: require('@/assets/smartLife/AIPhotography/db/1-4.jpg'),
  AIPhotographyDbIndex5: require('@/assets/smartLife/AIPhotography/db/1-5.jpg'),
  AIPhotographyDbIndex6: require('@/assets/smartLife/AIPhotography/db/1-6.jpg'),
  AIPhotographyDbIndex7: require('@/assets/smartLife/AIPhotography/db/1-7.jpg'),
  AIPhotographyDbIndex8: require('@/assets/smartLife/AIPhotography/db/1-8.jpg'),
  AIPhotographyDbIndex9: require('@/assets/smartLife/AIPhotography/db/1-9.jpg'),
  AIPhotographyDbIndex10: require('@/assets/smartLife/AIPhotography/db/1-10.jpg'),
  AIPhotographyDbIndex11: require('@/assets/smartLife/AIPhotography/db/1-11.jpg'),
  AIPhotographyDbIndex12: require('@/assets/smartLife/AIPhotography/db/1-12.jpg'),
  AIPhotographyDbIndex13: require('@/assets/smartLife/AIPhotography/db/1-13.jpg'),
  AIPhotographyDbIndex14: require('@/assets/smartLife/AIPhotography/db/1-14.jpg'),

  // AI写真，即梦
  AIPhotographyJmIndex2: require('@/assets/smartLife/AIPhotography/jm/1-2.jpg'),
  AIPhotographyJmIndex3: require('@/assets/smartLife/AIPhotography/jm/1-3.jpg'),
  AIPhotographyJmIndex4: require('@/assets/smartLife/AIPhotography/jm/1-4.jpg'),
  AIPhotographyJmIndex5: require('@/assets/smartLife/AIPhotography/jm/1-5.jpg'),
  AIPhotographyJmIndex6: require('@/assets/smartLife/AIPhotography/jm/1-6.jpg'),
  AIPhotographyJmIndex7: require('@/assets/smartLife/AIPhotography/jm/1-7.jpg'),
  AIPhotographyJmIndex8: require('@/assets/smartLife/AIPhotography/jm/1-8.jpg'),
  AIPhotographyJmIndex9: require('@/assets/smartLife/AIPhotography/jm/1-9.jpg'),
  AIPhotographyJmIndex10: require('@/assets/smartLife/AIPhotography/jm/1-10.jpg'),
  AIPhotographyJmIndex11: require('@/assets/smartLife/AIPhotography/jm/1-11.jpg'),
  AIPhotographyJmIndex12: require('@/assets/smartLife/AIPhotography/jm/1-12.jpg'),
  AIPhotographyJmIndex13: require('@/assets/smartLife/AIPhotography/jm/1-13.jpg'),

  // AI修图，豆包
  AIImageEditingDbIndex2: require('@/assets/smartLife/AIImageEditing/db/1-2.jpg'),
  AIImageEditingDbIndex3: require('@/assets/smartLife/AIImageEditing/db/1-3.jpg'),
  AIImageEditingDbIndex4: require('@/assets/smartLife/AIImageEditing/db/1-4.jpg'),
  AIImageEditingDbIndex5: require('@/assets/smartLife/AIImageEditing/db/1-5.jpg'),
  AIImageEditingDbIndex6: require('@/assets/smartLife/AIImageEditing/db/1-6.jpg'),
  AIImageEditingDbIndex7: require('@/assets/smartLife/AIImageEditing/db/1-7.jpg'),
  AIImageEditingDbIndex8: require('@/assets/smartLife/AIImageEditing/db/1-8.jpg'),
  AIImageEditingDbIndex9: require('@/assets/smartLife/AIImageEditing/db/1-9.jpg'),
  AIImageEditingDbIndex10: require('@/assets/smartLife/AIImageEditing/db/1-10.jpg'),
  AIImageEditingDbIndex11: require('@/assets/smartLife/AIImageEditing/db/1-11.jpg'),
  AIImageEditingDbIndex12: require('@/assets/smartLife/AIImageEditing/db/1-12.jpg'),
  AIImageEditingDbIndex13: require('@/assets/smartLife/AIImageEditing/db/1-13.jpg'),
  AIImageEditingDbIndex14: require('@/assets/smartLife/AIImageEditing/db/1-14.jpg'),
  AIImageEditingDbIndex15: require('@/assets/smartLife/AIImageEditing/db/1-15.jpg'),
  AIImageEditingDbIndex16: require('@/assets/smartLife/AIImageEditing/db/1-16.jpg'),
  AIImageEditingDbIndex17: require('@/assets/smartLife/AIImageEditing/db/1-17.jpg'),
  // AI修图，豆包，分支1
  AIImageEditingDbBranch1Index1: require('@/assets/smartLife/AIImageEditing/db/2-1.jpg'),
  AIImageEditingDbBranch1Index2: require('@/assets/smartLife/AIImageEditing/db/2-2.jpg'),
  AIImageEditingDbBranch1Index3: require('@/assets/smartLife/AIImageEditing/db/2-3.jpg'),
  AIImageEditingDbBranch1Index4: require('@/assets/smartLife/AIImageEditing/db/2-4.jpg'),
  AIImageEditingDbBranch1Index5: require('@/assets/smartLife/AIImageEditing/db/2-5.jpg'),
  AIImageEditingDbBranch1Index6: require('@/assets/smartLife/AIImageEditing/db/2-6.jpg'),
  AIImageEditingDbBranch1Index7: require('@/assets/smartLife/AIImageEditing/db/2-7.jpg'),

  // AI修图，即梦
  AIImageEditingJmIndex2: require('@/assets/smartLife/AIImageEditing/jm/1-2.jpg'),
  AIImageEditingJmIndex3: require('@/assets/smartLife/AIImageEditing/jm/1-3.jpg'),
  AIImageEditingJmIndex4: require('@/assets/smartLife/AIImageEditing/jm/1-4.jpg'),
  AIImageEditingJmIndex5: require('@/assets/smartLife/AIImageEditing/jm/1-5.jpg'),
  AIImageEditingJmIndex6: require('@/assets/smartLife/AIImageEditing/jm/1-6.jpg'),
  AIImageEditingJmIndex7: require('@/assets/smartLife/AIImageEditing/jm/1-7.jpg'),
  AIImageEditingJmIndex8: require('@/assets/smartLife/AIImageEditing/jm/1-8.jpg'),
  AIImageEditingJmIndex9: require('@/assets/smartLife/AIImageEditing/jm/1-9.jpg'),
  AIImageEditingJmIndex10: require('@/assets/smartLife/AIImageEditing/jm/1-10.jpg'),

  // AI音乐，豆包
  AIMusicDbIndex2: require('@/assets/smartLife/AIMusic/db/1-2.jpg'),
  AIMusicDbIndex3: require('@/assets/smartLife/AIMusic/db/1-3.jpg'),
  AIMusicDbIndex4: require('@/assets/smartLife/AIMusic/db/1-4.jpg'),
  AIMusicDbIndex5: require('@/assets/smartLife/AIMusic/db/1-5.jpg'),
  AIMusicDbIndex6: require('@/assets/smartLife/AIMusic/db/1-6.jpg'),
  AIMusicDbIndex7: require('@/assets/smartLife/AIMusic/db/1-7.jpg'),
  AIMusicDbIndex8: require('@/assets/smartLife/AIMusic/db/1-8.jpg'),
  AIMusicDbIndex9: require('@/assets/smartLife/AIMusic/db/1-9.jpg'),
  AIMusicDbIndex10: require('@/assets/smartLife/AIMusic/db/1-10.jpg'),
  AIMusicDbIndex11: require('@/assets/smartLife/AIMusic/db/1-11.jpg'),
  AIMusicDbIndex12: require('@/assets/smartLife/AIMusic/db/1-12.jpg'),
  AIMusicDbIndex13: require('@/assets/smartLife/AIMusic/db/1-13.jpg'),
  AIMusicDbIndex14: require('@/assets/smartLife/AIMusic/db/1-14.jpg'),
  AIMusicDbIndex15: require('@/assets/smartLife/AIMusic/db/1-15.jpg'),
  AIMusicDbIndex16: require('@/assets/smartLife/AIMusic/db/1-16.jpg'),

  // AI音乐，suno
  AIMusicSunoIndex2: require('@/assets/smartLife/AIMusic/suno/1-2.jpg'),
  AIMusicSunoIndex3: require('@/assets/smartLife/AIMusic/suno/1-3.jpg'),
  AIMusicSunoIndex4: require('@/assets/smartLife/AIMusic/suno/1-4.jpg'),
  AIMusicSunoIndex5: require('@/assets/smartLife/AIMusic/suno/1-5.jpg'),
  AIMusicSunoIndex6: require('@/assets/smartLife/AIMusic/suno/1-6.jpg'),
  AIMusicSunoIndex7: require('@/assets/smartLife/AIMusic/suno/1-7.jpg'),
  AIMusicSunoIndex8: require('@/assets/smartLife/AIMusic/suno/1-8.jpg'),
  AIMusicSunoIndex9: require('@/assets/smartLife/AIMusic/suno/1-9.jpg'),

  // AI数字人，即梦
  AIDigitalHumanJmIndex2: require('@/assets/smartLife/AIDigitalHuman/jm/1-2.jpg'),
  AIDigitalHumanJmIndex3: require('@/assets/smartLife/AIDigitalHuman/jm/1-3.jpg'),
  AIDigitalHumanJmIndex4: require('@/assets/smartLife/AIDigitalHuman/jm/1-4.jpg'),
  AIDigitalHumanJmIndex5: require('@/assets/smartLife/AIDigitalHuman/jm/1-5.jpg'),
  AIDigitalHumanJmIndex6: require('@/assets/smartLife/AIDigitalHuman/jm/1-6.jpg'),
  AIDigitalHumanJmIndex7: require('@/assets/smartLife/AIDigitalHuman/jm/1-7.jpg'),
  AIDigitalHumanJmIndex8: require('@/assets/smartLife/AIDigitalHuman/jm/1-8.jpg'),
  AIDigitalHumanJmIndex9: require('@/assets/smartLife/AIDigitalHuman/jm/1-9.jpg'),
  AIDigitalHumanJmIndex10: require('@/assets/smartLife/AIDigitalHuman/jm/1-10.jpg'),
  AIDigitalHumanJmIndex11: require('@/assets/smartLife/AIDigitalHuman/jm/1-11.jpg'),
  AIDigitalHumanJmIndex12: require('@/assets/smartLife/AIDigitalHuman/jm/1-12.jpg'),
  AIDigitalHumanJmIndex13: require('@/assets/smartLife/AIDigitalHuman/jm/1-13.jpg'),
  AIDigitalHumanJmIndex14: require('@/assets/smartLife/AIDigitalHuman/jm/1-14.jpg'),


  // AI写作
  AIWritingDbIndex2: require('@/assets/smartLife/AIWriting/db/1-2.jpg'),
  AIWritingDbIndex3: require('@/assets/smartLife/AIWriting/db/1-3.jpg'),
  AIWritingDbIndex4: require('@/assets/smartLife/AIWriting/db/1-4.jpg'),
  AIWritingDbIndex5: require('@/assets/smartLife/AIWriting/db/1-5.jpg'),
  AIWritingDbIndex6: require('@/assets/smartLife/AIWriting/db/1-6.jpg'),
  AIWritingDbIndex7: require('@/assets/smartLife/AIWriting/db/1-7.jpg'),
  AIWritingDbIndex8: require('@/assets/smartLife/AIWriting/db/1-8.jpg'),
  AIWritingDbIndex9: require('@/assets/smartLife/AIWriting/db/1-9.jpg'),
  AIWritingDbIndex10: require('@/assets/smartLife/AIWriting/db/1-10.jpg'),
  AIWritingDbIndex11: require('@/assets/smartLife/AIWriting/db/1-11.jpg'),

  AIWritingDpIndex2: require('@/assets/smartLife/AIWriting/dp/1-2.jpg'),
  AIWritingDpIndex3: require('@/assets/smartLife/AIWriting/dp/1-3.jpg'),
  AIWritingDpIndex4: require('@/assets/smartLife/AIWriting/dp/1-4.jpg'),
  AIWritingDpIndex5: require('@/assets/smartLife/AIWriting/dp/1-5.jpg'),
  AIWritingDpIndex6: require('@/assets/smartLife/AIWriting/dp/1-6.jpg'),
  AIWritingDpIndex7: require('@/assets/smartLife/AIWriting/dp/1-7.jpg'),
  AIWritingDpIndex8: require('@/assets/smartLife/AIWriting/dp/1-8.jpg'),


}
